import React, { useState, useEffect } from 'react';
import { ShieldAlert, Users, Award, BookOpen, Layers, Send, Save, CheckCircle, HelpCircle, HardDrive, RefreshCw, Star, ArrowRight, ClipboardList, Briefcase, Eye, Activity, ShieldCheck, Key, Lock, LogOut, MessageSquare, CheckSquare, DollarSign, ListTodo, Sparkles, Search, Compass, TrendingUp, Mail, Flame, Award as GoldBadge, Monitor, Smartphone, MessageCircle, FileText, Settings, AlertOctagon, Archive, CheckCircle2, AlertTriangle, UserCheck } from 'lucide-react';

interface NexoraXOperatorConsoleProps {
  userRole?: string;
  userEmail?: string;
  initialMode?: 'console' | 'onboarding' | 'login' | 'control_embed';
}

const OPPORTUNITY_TYPES = [
  "Website", "One-page LaunchCare", "Three-page LaunchCare", "Six-page LaunchCare",
  "Website Redesign", "Business Email / Domain", "Hosting / Maintenance",
  "QR Campaign", "QR Menu / Restaurant", "Booking System", "CRM / Dashboard",
  "Customer Portal", "AI Voice Assistant", "AI Avatar", "Social Media Campaign",
  "Email Campaign", "SEO Campaign", "Driver / Courier / Fleet", "Taxi / Dispatch",
  "POS System", "CCTV / Security", "Inventory System", "Quote / Invoice System",
  "Automation Workflow", "Mobile App", "Marketplace Product", "Digital Product Template",
  "PDF / Proposal Pack", "Pitch Deck", "Calculator Tool", "Charity / Community System",
  "Government / Public Sector Opportunity", "Enterprise / Custom Quote", "Other"
];

export const NexoraXOperatorConsole: React.FC<NexoraXOperatorConsoleProps> = ({ userRole = 'OPERATOR', userEmail, initialMode = 'console' }) => {
  const isEmbed = initialMode === 'control_embed';
  // Authentication State
  const [viewMode, setViewMode] = useState<'console' | 'onboarding' | 'login'>(isEmbed ? 'console' : initialMode);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(isEmbed ? true : (initialMode === 'console'));
  const [authStep, setAuthStep] = useState<'login' | 'mfa'>('login');
  const [credentials, setCredentials] = useState({ email: isEmbed ? 'siddique.mahmood@gmail.com' : (userEmail || ''), password: '' });
  const [mfaCode, setMfaCode] = useState<string>('');
  const [loggedOut, setLoggedOut] = useState<boolean>(false);

  // Local fetch override to inject staging email bypass header
  const fetch = (url: RequestInfo | URL, init?: RequestInit) => {
    const headers = new Headers(init?.headers);
    if (credentials.email) {
      headers.set('x-operator-staging-email', credentials.email);
    }
    return window.fetch(url, { ...init, headers });
  };
  
  // Workspace and Identity States
  const [currentProfile, setCurrentProfile] = useState<any>(null);
  const [currentWorkspace, setCurrentWorkspace] = useState<any>(null);
  const [currentSession, setCurrentSession] = useState<any>(null);
  
  const [operatorsList, setOperatorsList] = useState<any[]>([]);
  const [workerNotes, setWorkerNotes] = useState<{[key: string]: string}>({});
  const [sessionsList, setSessionsList] = useState<any[]>([]);
  const [auditLogsList, setAuditLogsList] = useState<any[]>([]);
  const [testResults, setTestResults] = useState<any[]>([]);
  const [isTestingSecurity, setIsTestingSecurity] = useState<boolean>(false);

  // Console Tab State
  const [consoleTab, setConsoleTab] = useState<'missions' | 'preview' | 'workbench' | 'studio' | 'suggestions' | 'review' | 'commissions' | 'training' | 'control'>(isEmbed ? 'control' : 'workbench');
  
  // Workbench Subtab State
  const [workbenchSubtab, setWorkbenchSubtab] = useState<'leadFinder' | 'analyzer' | 'checker' | 'outreach' | 'productQueue' | 'completedHistory'>('leadFinder');

  const [controlSubtab, setControlSubtab] = useState<string>('01. Overview');

  // Staging Stores States
  const [buildTasks, setBuildTasks] = useState<any[]>([]);
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [commissions, setCommissions] = useState<any[]>([]);
  const [leadTasks, setLeadTasks] = useState<any[]>([]);
  const [activeOpportunities, setActiveOpportunities] = useState<any[]>([]);
  const [completedOpportunities, setCompletedOpportunities] = useState<any[]>([]);
  const [outreachDrafts, setOutreachDrafts] = useState<any[]>([]);
  const [productResearch, setProductResearch] = useState<any[]>([]);
  const [marketplaceResearch, setMarketplaceResearch] = useState<any[]>([]);
  const [nextTasksList, setNextTasksList] = useState<string[]>([]);
  const [previewsList, setPreviewsList] = useState<any[]>([]);
  
  // Invite and Worker Onboarding/Login States
  const [invitesList, setInvitesList] = useState<any[]>([]);
  const [inviteForm, setInviteForm] = useState({ worker_name: '', worker_email: '', commission_type: 'Standard Percentage', notes: '' });
  const [onboardingForm, setOnboardingForm] = useState({ invite_code: '', name: '', email: '', phone: '', location: '' });
  const [agreementAccepted, setAgreementAccepted] = useState<boolean>(false);
  const [rulesAccepted, setRulesAccepted] = useState<boolean>(false);
  const [loginForm, setLoginForm] = useState({ email: '', invite_code: '' });
  
  // Scraper lead cards state
  const [searchedLeads, setSearchedLeads] = useState<any[]>([]);

  // --- NEW WORKFORCE OS STATE VARIABLE UPGRADE ---
  const [productionTasks, setProductionTasks] = useState<any[]>([]);
  const [specialistsList, setSpecialistsList] = useState<any[]>([]);
  const [workforceAuditLogs, setWorkforceAuditLogs] = useState<any[]>([]);

  // --- REMOTE WORKFORCE OS IDENTITY VERIFICATION & TRAFFIC STATS STATES ---
  const [verificationsList, setVerificationsList] = useState<any[]>([]);
  const [myVerification, setMyVerification] = useState<any | null>(null);
  const [trafficStats, setTrafficStats] = useState<any | null>(null);

  // Forms for Worker Onboarding ID Verification
  const [verificationForm, setVerificationForm] = useState({
    fullName: '',
    phone: '',
    country: 'Pakistan',
    timezone: 'PKT (UTC+5)',
    workerRole: 'Remote Campaign / Canva / Video Helper',
    idType: 'passport'
  });
  const [idFile, setIdFile] = useState<any | null>(null);
  const [selfieFile, setSelfieFile] = useState<any | null>(null);

  // Checkboxes for Worker Onboarding Agreement
  const [agreeOS, setAgreeOS] = useState(false);
  const [agreeCreds, setAgreeCreds] = useState(false);
  const [agreeReview, setAgreeReview] = useState(false);
  const [agreeComm, setAgreeComm] = useState(false);
  const [agreeLeads, setAgreeLeads] = useState(false);
  const [agreeVerify, setAgreeVerify] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);

  // UTM Generator Form
  const [utmForm, setUtmForm] = useState({
    campaignName: '',
    source: 'facebook',
    medium: 'social',
    category: 'qr_campaign',
    destination: 'homepage',
    destinationUrl: ''
  });
  const [generatedUtmUrl, setGeneratedUtmUrl] = useState('');

  // Director Review Verification State
  const [selectedVerForReview, setSelectedVerForReview] = useState<any | null>(null);
  const [verReviewForm, setVerReviewForm] = useState({
    status: 'Verified',
    directorNotes: ''
  });

  const [showCreateTaskModal, setShowCreateTaskModal] = useState<boolean>(false);
  const [newTaskForm, setNewTaskForm] = useState({
    title: '',
    type: 'Campaign Tasks',
    platform: 'TikTok',
    priority: 'High',
    dueDate: '',
    brief: '',
    assetLinks: '',
    requiredOutput: 'Completed social post draft or uploaded video file.',
    estimatedCommission: '15.00',
    // Canva/Video Tasks Fields
    duration: '15s',
    voiceStyle: 'Professional UK Male',
    musicStyle: 'Tech Sub-Bass Hum',
    captionToUse: '',
    finalCta: '',
    uploadInstructions: 'Upload to staging.',
    // Hardware Configuration Fields
    customerBudget: '',
    usageType: 'General Office Work',
    preferredBrand: 'Samsung / Lenovo',
    deviceFormat: 'Laptop',
    accessories: '',
    warrantySupport: '1 Year Return to Base'
  });

  const [showCreateSpecialistModal, setShowCreateSpecialistModal] = useState<boolean>(false);
  const [newSpecialistForm, setNewSpecialistForm] = useState({
    name: '',
    country: 'United Kingdom',
    timezone: 'BST (UTC+1)',
    category: 'Canva / CapCut Video Creators',
    skills: '',
    basis: 'Hourly - £15.00/hr',
    availability: 'Part-Time (20 hrs/week)',
    portfolioLink: '',
    status: 'approved',
    notes: ''
  });

  const [selectedTaskForReview, setSelectedTaskForReview] = useState<any | null>(null);
  const [directorReviewForm, setDirectorReviewForm] = useState({
    status: 'Approved',
    directorNotes: ''
  });

  const [selectedTaskForDetails, setSelectedTaskForDetails] = useState<any | null>(null);
  const [workerSubmitForm, setWorkerSubmitForm] = useState({
    completedFileLink: '',
    workerComments: ''
  });
  const [workerMissionsTab, setWorkerMissionsTab] = useState<'build' | 'production'>('production');
  
  const [loading, setLoading] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);

  // Forms State
  const [leadSearchForm, setLeadSearchForm] = useState({ keyword: 'takeaway', location: 'Fife', searchNotes: '', opportunityType: 'Website' });

  // Phase 4 Forms State
  const [leadFinderForm, setLeadFinderForm] = useState({
    businessName: '', industry: '', location: '', websiteUrl: '', socialUrl: '',
    phone: '', publicEmail: '', reviewScore: '4.0', reviewCount: '12', searchIntent: 'Website opportunity', notes: ''
  });

  const [analyzerForm, setAnalyzerForm] = useState({
    selectedOppId: '', businessName: '', websiteUrl: '', socialUrl: '', reviewScore: '4.2', reviewCount: '28', problemSpotted: '', suggestedService: 'LaunchCare Premier £50', notes: ''
  });
  const [advisorAnalysis, setAdvisorAnalysis] = useState<any>(null);

  const [checkerForm, setCheckerForm] = useState({
    websiteExists: 'Yes', mobileQuality: 'Average', designQuality: 'Average', ctaVisible: 'Yes', bookingForm: 'No',
    businessEmailVisible: 'Yes', socialPresence: 'Average', reviewsStatus: 'Average',
    problemSpotted: '', suggestedImprovement: '', screenshotRef: ''
  });
  const [checkerResult, setCheckerResult] = useState<any>(null);

  const [outreachForm, setOutreachForm] = useState({
    selectedOppId: '', businessName: '', outreachAngle: 'Introduce LaunchCare professional website setup and custom branding.', painPoint: '', suggestedImprovement: '', messageTone: 'Professional & Direct', notes: '', recipientEmail: ''
  });
  const [generatedOutreachText, setGeneratedOutreachText] = useState<string>('');

  const [productResearchForm, setProductResearchForm] = useState({
    productName: '', category: 'Templates & Apps', sourceType: 'TikTok', sourceLink: '', targetCustomer: '', whyItCouldSell: '', notes: ''
  });
  const [productAnalysisResult, setProductAnalysisResult] = useState<any>(null);
  const [productSuggestions, setProductSuggestions] = useState<string>('');

  const [submittingTaskId, setSubmittingTaskId] = useState<string | null>(null);
  const [submitDetails, setSubmitDetails] = useState({ screenshotRef: '', progressNotes: '', addOnsList: '', mobileNotes: '' });

  // Suggestion form
  const [suggestionForm, setSuggestionForm] = useState({
    title: '', type: 'Design Improvement', description: '', whyItHelps: '', relatedTask: '', estimatedValue: 'Medium', operatorNotes: ''
  });
  const [advisorResponse, setAdvisorResponse] = useState<any>(null);

  // Director assignment form
  const [directorAssignForm, setDirectorAssignForm] = useState({
    operatorId: '', taskTitle: '', category: 'Design Template', brief: '', dueDate: '', priority: 'MEDIUM'
  });

  // Live Draft Preview form state
  const [editingPreviewId, setEditingPreviewId] = useState<string | null>(null);
  const [previewForm, setPreviewForm] = useState({
    desktopPreviewRef: '',
    mobilePreviewRef: '',
    screenshotRef: '',
    visualFeedbackNotes: '',
    designImprovementNotes: '',
    blockers: '',
    completionPercentage: '0'
  });

  // AI Quality review checklist parameters for draft preview
  const [designReviewChecklist, setDesignReviewChecklist] = useState({
    purpleGlassStyle: false,
    mobileFirst: false,
    modulesIncluded: false,
    ctaVisible: false,
    gbpPricingUsed: false,
    contactCorrect: false,
    noSpellingMistakes: false,
    noHiddenTools: false,
    screenshotIncluded: false
  });
  const [aiReviewFeedback, setAiReviewFeedback] = useState<any>(null);

  // Selected lead context for checklist
  const [selectedLeadForChecklist, setSelectedLeadForChecklist] = useState<any | null>(null);
  const [leadChecklist, setLeadChecklist] = useState({
    reviewedName: false,
    checkedWebsite: false,
    checkedSocial: false,
    checkedReviews: false,
    opportunityTypeSelected: false,
    problemNoticed: false,
    ranAdvisorAnalysis: false,
    selectedSuggestedOffer: false
  });

  const triggerToast = (msg: string) => {
    setToastMessage(msg);
    setTimeout(() => setToastMessage(null), 4000);;
  };

  // Sync data from store endpoints
  const syncData = async () => {
    setLoading(true);
    try {
      // Identity & Workspace info
      const meRes = await fetch('/api/operator/me');
      const meData = await meRes.json();
      if (meData.success) {
        setCurrentProfile(meData.profile);
        const role = meData.profile.role;
        const isDir = ["DIRECTOR", "ADMIN", "SUPER_ADMIN"].includes(role);
        
        if (isDir) {
          const opsRes = await fetch('/api/operator/admin/operators');
          const opsData = await opsRes.json();
          if (opsData.success) setOperatorsList(opsData.operators);

          const sessRes = await fetch('/api/operator/admin/sessions');
          const sessData = await sessRes.json();
          if (sessData.success) setSessionsList(sessData.sessions);

          const auditRes = await fetch('/api/operator/admin/audit');
          const auditData = await auditRes.json();
          if (auditData.success) setAuditLogsList(auditData.logs);

          const invRes = await fetch('/api/operator/admin/invites');
          const invData = await invRes.json();
          if (invData.success) setInvitesList(invData.invites);
        }
      }

      const wsRes = await fetch('/api/operator/workspace');
      const wsData = await wsRes.json();
      if (wsData.success) setCurrentWorkspace(wsData.workspace);

      const sessInfoRes = await fetch('/api/operator/session');
      const sessInfoData = await sessInfoRes.json();
      if (sessInfoData.success) setCurrentSession(sessInfoData.session);

      // Remote Workforce OS Stores
      try {
        const wfTasksRes = await fetch('/api/admin/workforce/tasks');
        const wfTasksData = await wfTasksRes.json();
        if (wfTasksData.success) setProductionTasks(wfTasksData.tasks);
      } catch (err) {}

      try {
        const checkRole = currentProfile?.role || (meData && meData.profile ? meData.profile.role : '');
        const isDirUser = ["DIRECTOR", "ADMIN", "SUPER_ADMIN"].includes(checkRole) || isEmbed;
        if (isDirUser) {
          const wfSpecsRes = await fetch('/api/admin/workforce/specialists');
          const wfSpecsData = await wfSpecsRes.json();
          if (wfSpecsData.success) setSpecialistsList(wfSpecsData.specialists);

          const wfLogsRes = await fetch('/api/admin/workforce/audit-log');
          const wfLogsData = await wfLogsRes.json();
          if (wfLogsData.success) setWorkforceAuditLogs(wfLogsData.logs);
        }
      } catch (err) {}

      // System stores
      const btRes = await fetch('/api/operator/build-tasks');
      const btData = await btRes.json();
      if (btData.success) setBuildTasks(btData.buildTasks);

      const sugRes = await fetch('/api/operator/suggestions');
      const sugData = await sugRes.json();
      if (sugData.success) setSuggestions(sugData.suggestions);

      const commRes = await fetch('/api/operator/commission');
      const commData = await commRes.json();
      if (commData.success) setCommissions(commData.commissions);

      const leadRes = await fetch('/api/operator/tasks');
      const leadData = await leadRes.json();
      if (leadData.success) setLeadTasks(leadData.tasks);

      // Active / Completed Leads Queues
      const activeRes = await fetch('/api/operator/leads/active');
      const activeData = await activeRes.json();
      if (activeData.success) setActiveOpportunities(activeData.opportunities);

      const completedRes = await fetch('/api/operator/leads/completed');
      const completedData = await completedRes.json();
      if (completedData.success) setCompletedOpportunities(completedData.opportunities);

      const outRes = await fetch('/api/operator/outreach-drafts');
      const outData = await outRes.json();
      if (outData.success) setOutreachDrafts(outData.outreachDrafts);

      const prodRes = await fetch('/api/operator/product-research');
      const prodData = await prodRes.json();
      if (prodData.success) setProductResearch(prodData.productResearch);

      const mktRes = await fetch('/api/operator/marketplace-research');
      const mktData = await mktRes.json();
      if (mktData.success) setMarketplaceResearch(mktData.marketplaceResearch);

      const nextRes = await fetch('/api/operator/next-task');
      const nextData = await nextRes.json();
      if (nextData.success) setNextTasksList(nextData.availableTasks);

      const prevRes = await fetch('/api/operator/previews');
      const prevData = await prevRes.json();
      if (prevData.success) setPreviewsList(prevData.previews);

      // Fetch workforce verification status
      try {
        const verRes = await fetch('/api/admin/workforce/verification');
        const verData = await verRes.json();
        if (verData.success) {
          setVerificationsList(verData.verifications);
          // Store my verification status
          const checkRole = currentProfile?.role || (meData && meData.profile ? meData.profile.role : '');
          const myEmail = currentProfile?.email || (meData && meData.profile ? meData.profile.email : '');
          const mine = verData.verifications.find((v: any) => v.email.toLowerCase() === myEmail.toLowerCase());
          if (mine) setMyVerification(mine);
        }
      } catch (err) {}

      // Fetch workforce traffic stats (Director/Admin only)
      try {
        const checkRole = currentProfile?.role || (meData && meData.profile ? meData.profile.role : '');
        const isDirUser = ["DIRECTOR", "ADMIN", "SUPER_ADMIN"].includes(checkRole) || isEmbed;
        if (isDirUser) {
          const trafficRes = await fetch('/api/admin/workforce/traffic/stats');
          const trafficData = await trafficRes.json();
          if (trafficData.success) setTrafficStats(trafficData.stats);
        }
      } catch (err) {}

    } catch (err) {
      console.warn("Failed to sync operator system stores:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      syncData();
      
      const checkInitialTab = () => {
        const initialTab = sessionStorage.getItem('workforce_os_initial_tab');
        if (initialTab) {
          setConsoleTab('control');
          setControlSubtab(initialTab);
          sessionStorage.removeItem('workforce_os_initial_tab');
        }
      };

      checkInitialTab();

      const handleTabTrigger = (e: Event) => {
        const customEvent = e as CustomEvent;
        if (customEvent.detail) {
          setConsoleTab('control');
          setControlSubtab(customEvent.detail);
        }
      };

      window.addEventListener('nexorax-trigger-workforce-tab', handleTabTrigger);
      
      try {
        const params = new URLSearchParams(window.location.search);
        const view = params.get('view');
        if (view === 'director-security') {
          setConsoleTab('control');
          setControlSubtab('10. Security Test');
        }
      } catch (err) {}

      return () => {
        window.removeEventListener('nexorax-trigger-workforce-tab', handleTabTrigger);
      };
    }
  }, [isAuthenticated]);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (code) {
        setOnboardingForm(prev => ({ ...prev, invite_code: code.toUpperCase() }));
      }
    } catch (e) {}
  }, [viewMode]);

  // Auth Mock Handlers
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (!credentials.email.includes('@')) {
      triggerToast("Invalid corporate email format.");
      return;
    }
    setAuthStep('mfa');
    triggerToast("Staging MFA: Mock SMS/Email code dispatched.");
  };

  const handleVerifyMfa = (e: React.FormEvent) => {
    e.preventDefault();
    if (mfaCode.length !== 6) {
      triggerToast("Verification code must be exactly 6 digits.");
      return;
    }
    setIsAuthenticated(true);
    setLoggedOut(false);
    triggerToast("Authentication Clear. Operator clearance matched.");
  };

  // Secure Logout
  const handleLogout = async () => {
    try {
      const res = await fetch('/api/operator/logout', { method: 'POST' });
      const data = await res.json();
      setIsAuthenticated(false);
      setLoggedOut(true);
      setAuthStep('login');
      setCredentials({ email: '', password: '' });
      setMfaCode('');
      localStorage.removeItem("nexorax_director_session");
      triggerToast(data.message || "You have safely logged out of NexoraX Remote Operator Portal. Your work has been saved.");
    } catch (err) {
      setIsAuthenticated(false);
      setLoggedOut(true);
      setAuthStep('login');
      localStorage.removeItem("nexorax_director_session");
    }
  };

  // Director workforce management actions
  const handleModifyOperatorStatus = async (opId: string, status: string) => {
    try {
      const res = await fetch(`/api/operator/admin/operators/${opId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Operator status updated to ${status}.`);
        syncData();
      }
    } catch (err) {
      triggerToast("Action failed.");
    }
  };

  const handleReviewWorkerVerification = async (email: string, status: string) => {
    try {
      const notes = workerNotes[email] || '';
      const verRecord = verificationsList.find(v => v.email.toLowerCase() === email.toLowerCase());
      const res = await fetch('/api/admin/workforce/verification/review', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          verificationId: verRecord ? verRecord.id : email,
          status,
          directorNotes: notes
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Worker verification status updated to ${status}.`);
        // Sync lists
        const opsRes = await fetch('/api/operator/admin/operators');
        const opsData = await opsRes.json();
        if (opsData.success) setOperatorsList(opsData.operators);
        
        const verRes = await fetch('/api/admin/workforce/verification');
        const verData = await verRes.json();
        if (verData.success) setVerificationsList(verData.verifications);
      } else {
        triggerToast(data.error || "Failed to update verification.");
      }
    } catch (err) {
      triggerToast("Error updating verification review.");
    }
  };

  const handleAssignTask = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!directorAssignForm.operatorId || !directorAssignForm.taskTitle) {
      triggerToast("Operator ID and Task Title are required.");
      return;
    }
    try {
      const res = await fetch('/api/operator/admin/assign-task', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(directorAssignForm)
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Task successfully assigned.");
        setDirectorAssignForm({ operatorId: '', taskTitle: '', category: 'Design Template', brief: '', dueDate: '', priority: 'MEDIUM' });
        syncData();
      }
    } catch (err) {
      triggerToast("Task assignment failed.");
    }
  };

  const handleReassignLead = async (leadId: string, targetOperatorId: string) => {
    try {
      const res = await fetch('/api/operator/admin/reassign-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ leadId, targetOperatorId })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Lead successfully reassigned.");
        syncData();
      }
    } catch (err) {
      triggerToast("Lead reassignment failed.");
    }
  };

  const handleApproveCommission = async (commId: string) => {
    try {
      const res = await fetch(`/api/operator/admin/commission/${commId}/approve`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Commission approved.");
        syncData();
      }
    } catch (err) {
      triggerToast("Approval failed.");
    }
  };

  const handleMarkPaidCommission = async (commId: string) => {
    try {
      const res = await fetch(`/api/operator/admin/commission/${commId}/mark-paid`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Commission marked paid.");
        syncData();
      }
    } catch (err) {
      triggerToast("Action failed.");
    }
  };

  const handleRunIsolationTest = async () => {
    setIsTestingSecurity(true);
    try {
      const res = await fetch('/api/operator/admin/test-isolation-security', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await res.json();
      if (data.success) {
        setTestResults(data.results);
        triggerToast("Isolation security tests executed successfully.");
      } else {
        triggerToast(data.error || "Tests execution failed.");
      }
    } catch (err) {
      triggerToast("Failed to request isolation security tests.");
    } finally {
      setIsTestingSecurity(false);
    }
  };

  const handleCreateInvite = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/operator/admin/invites', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inviteForm)
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Invite created. Code: ${data.invite.invite_code}`);
        setInviteForm({ worker_name: '', worker_email: '', commission_type: 'Standard Percentage', notes: '' });
        // Sync lists
        const invRes = await fetch('/api/operator/admin/invites');
        const invData = await invRes.json();
        if (invData.success) setInvitesList(invData.invites);
      } else {
        triggerToast(data.error || "Failed to create invite.");
      }
    } catch (err) {
      triggerToast("Network error creating invite.");
    }
  };

  // --- REMOTE WORKFORCE OS UPGRADE HANDLERS ---
  const handleCreateTask = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/admin/workforce/tasks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newTaskForm)
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Production task created: ${data.task.title}`);
        setShowCreateTaskModal(false);
        setNewTaskForm({
          title: '',
          type: 'Campaign Tasks',
          platform: 'TikTok',
          priority: 'High',
          dueDate: '',
          brief: '',
          assetLinks: '',
          requiredOutput: 'Completed social post draft or uploaded video file.',
          estimatedCommission: '15.00',
          duration: '15s',
          voiceStyle: 'Professional UK Male',
          musicStyle: 'Tech Sub-Bass Hum',
          captionToUse: '',
          finalCta: '',
          uploadInstructions: 'Upload to staging.',
          customerBudget: '',
          usageType: 'General Office Work',
          preferredBrand: 'Samsung / Lenovo',
          deviceFormat: 'Laptop',
          accessories: '',
          warrantySupport: '1 Year Return to Base'
        });
        syncData();
      } else {
        triggerToast(data.error || "Failed to create production task.");
      }
    } catch (err) {
      triggerToast("Network error creating task.");
    }
  };

  const handleClaimTask = async (taskId: string) => {
    try {
      const res = await fetch('/api/admin/workforce/tasks/claim', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ taskId })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Task claimed successfully!");
        syncData();
      } else {
        triggerToast(data.error || "Failed to claim task.");
      }
    } catch (err) {
      triggerToast("Network error claiming task.");
    }
  };

  const handleWorkerSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedTaskForDetails) return;
    try {
      const res = await fetch('/api/admin/workforce/tasks/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          taskId: selectedTaskForDetails.id,
          completedFileLink: workerSubmitForm.completedFileLink,
          workerComments: workerSubmitForm.workerComments
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Work submitted for review!");
        setSelectedTaskForDetails(null);
        setWorkerSubmitForm({ completedFileLink: '', workerComments: '' });
        syncData();
      } else {
        triggerToast(data.error || "Failed to submit work.");
      }
    } catch (err) {
      triggerToast("Network error submitting work.");
    }
  };

  const handleReviewSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedTaskForReview) return;
    try {
      const res = await fetch('/api/admin/workforce/tasks/review', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          taskId: selectedTaskForReview.id,
          status: directorReviewForm.status,
          directorNotes: directorReviewForm.directorNotes
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Task review updated to: ${directorReviewForm.status}`);
        setSelectedTaskForReview(null);
        setDirectorReviewForm({ status: 'Approved', directorNotes: '' });
        syncData();
      } else {
        triggerToast(data.error || "Failed to update review.");
      }
    } catch (err) {
      triggerToast("Network error submitting review.");
    }
  };

  const handleCreateSpecialist = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/admin/workforce/specialists', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newSpecialistForm)
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Added specialist candidate: ${data.specialist.name}`);
        setShowCreateSpecialistModal(false);
        setNewSpecialistForm({
          name: '',
          country: 'United Kingdom',
          timezone: 'BST (UTC+1)',
          category: 'Canva / CapCut Video Creators',
          skills: '',
          basis: 'Hourly - £15.00/hr',
          availability: 'Part-Time (20 hrs/week)',
          portfolioLink: '',
          status: 'approved',
          notes: ''
        });
        syncData();
      } else {
        triggerToast(data.error || "Failed to add specialist.");
      }
    } catch (err) {
      triggerToast("Network error adding specialist.");
    }
  };


  const handleCancelInvite = async (inviteId: string) => {
    try {
      const res = await fetch(`/api/operator/admin/invites/${inviteId}/cancel`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Invite cancelled.");
        // Sync lists
        const invRes = await fetch('/api/operator/admin/invites');
        const invData = await invRes.json();
        if (invData.success) setInvitesList(invData.invites);
      }
    } catch (err) {
      triggerToast("Failed to cancel invite.");
    }
  };

  // --- RENDER WORKFORCE OS UPGRADE VIEWS & MODALS ---
  const renderProductionHubSubtab = () => {
    const availableTasks = productionTasks.filter(t => t.status === 'Available');
    const assignedTasks = productionTasks.filter(t => t.status === 'Assigned' || t.status === 'In Progress');
    const submittedTasks = productionTasks.filter(t => t.status === 'Submitted');
    const approvedTasks = productionTasks.filter(t => t.status === 'Approved');

    return (
      <div className="space-y-6 text-[10.5px] font-mono">
        {/* Director Demo / Bank Preview Banner */}
        <div className="bg-[#0c1020]/90 border border-cyan-500/25 p-5 rounded-3xl space-y-3 shadow-[0_0_30px_rgba(6,182,212,0.1)] text-left">
          <div className="flex items-center gap-2 text-cyan-300 font-bold uppercase text-[9px] tracking-[0.25em]">
            <span className="w-2 h-2 bg-cyan-500 rounded-full animate-ping" />
            <span>Operational Compliance Matrix & Bank Verification Layer</span>
          </div>
          <h3 className="text-white font-black text-sm uppercase">Secure Sandboxed Remote Workforce Coordination</h3>
          <p className="text-slate-350 leading-relaxed text-[9.5px]">
            NexoraX Remote Workforce OS provides a structured, sandboxed workspace for third-party creative and technical operators. 
            All outbound B2B pitches, social media drafts, and custom layouts are retained in the staging queue. 
            No direct access to production databases, payment links, credentials, or live mail channels is permitted. 
            Any operator commission is calculated as an estimate, which is subject to final Director approval and client payment verification before being marked as eligible.
          </p>
          <div className="flex flex-wrap gap-4 text-[8.5px] font-bold text-slate-500 uppercase pt-1">
            <div>✓ Director-Approved Workflow</div>
            <div>✓ Sandboxed Node Infrastructure</div>
            <div>✓ Guided Task Production</div>
            <div>✓ Commission Subject to Payment Verification</div>
          </div>
        </div>

        {/* Production Metrics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="p-4 bg-zinc-950/60 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[9px] font-bold">Total Specialists</div>
            <div className="text-2xl font-black text-white mt-1">{specialistsList.length}</div>
            <div className="text-slate-400 text-[8px] mt-1">Active: {specialistsList.filter(s => s.status === 'active' || s.status === 'approved').length}</div>
          </div>
          <div className="p-4 bg-zinc-950/60 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[9px] font-bold">Claimable Tasks</div>
            <div className="text-2xl font-black text-cyan-400 mt-1">{availableTasks.length}</div>
            <div className="text-slate-400 text-[8px] mt-1">Waiting for workers</div>
          </div>
          <div className="p-4 bg-zinc-950/60 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[9px] font-bold">Pending Review</div>
            <div className="text-2xl font-black text-yellow-400 mt-1">{submittedTasks.length}</div>
            <div className="text-slate-400 text-[8px] mt-1">Requires Director approval</div>
          </div>
          <div className="p-4 bg-zinc-950/60 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[9px] font-bold">Approved Tasks</div>
            <div className="text-2xl font-black text-emerald-400 mt-1">{approvedTasks.length}</div>
            <div className="text-slate-400 text-[8px] mt-1">Commissions dispatched</div>
          </div>
        </div>

        {/* Action Buttons Row */}
        <div className="flex gap-2">
          <button
            onClick={() => setShowCreateTaskModal(true)}
            className="px-4 py-2 bg-cyan-900/40 border border-cyan-500/30 hover:bg-cyan-800/40 text-cyan-300 font-bold uppercase rounded-xl cursor-pointer"
          >
            ➕ Create New Production Task
          </button>
          <button
            onClick={() => setShowCreateSpecialistModal(true)}
            className="px-4 py-2 bg-purple-900/40 border border-purple-500/30 hover:bg-purple-800/40 text-purple-300 font-bold uppercase rounded-xl cursor-pointer"
          >
            ➕ Register Specialist Candidate
          </button>
        </div>

        {/* Task lists & Specialists split */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 text-left">
          {/* Columns 1 & 2: Task Production Board */}
          <div className="lg:col-span-2 space-y-4">
            <div className="flex justify-between items-center border-b border-zinc-900 pb-2">
              <div className="text-white font-bold uppercase text-[11px] tracking-wider">Worker Production Tasks</div>
              <div className="text-slate-500 text-[9px]">{productionTasks.length} Tasks Total</div>
            </div>

            {productionTasks.length === 0 ? (
              <div className="p-6 text-center text-slate-500 border border-zinc-900 rounded-2xl bg-zinc-950/40">
                No production tasks created yet. Repurpose campaigns or click Create Task above.
              </div>
            ) : (
              <div className="space-y-3">
                {productionTasks.map((task) => (
                  <div key={task.id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-3">
                    <div className="flex justify-between items-start">
                      <div>
                        <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase mr-2 ${
                          task.priority === 'High' ? 'bg-red-950 text-red-400 border border-red-500/20' : 'bg-slate-900 text-slate-400'
                        }`}>
                          {task.priority}
                        </span>
                        <span className="text-slate-500 text-[9px] uppercase">{task.type}</span>
                        <h4 className="text-white font-bold mt-1 text-xs">{task.title}</h4>
                      </div>
                      <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${
                        task.status === 'Available' ? 'bg-cyan-950 text-cyan-400 border border-cyan-500/20 animate-pulse' :
                        task.status === 'Submitted' ? 'bg-yellow-950 text-yellow-400 border border-yellow-500/20' :
                        task.status === 'Approved' ? 'bg-emerald-950 text-emerald-400 border border-emerald-500/20' :
                        'bg-zinc-900 text-slate-400'
                      }`}>
                        {task.status}
                      </span>
                    </div>

                    <p className="text-slate-300 leading-relaxed text-[10px]">{task.brief}</p>

                    {/* Task Parameter Templates Details */}
                    {(task.captionToUse || task.customerBudget) && (
                      <div className="p-3 bg-black/45 border border-zinc-900/60 rounded-xl space-y-1.5 text-[9px]">
                        <div className="text-slate-550 font-bold uppercase border-b border-zinc-900/40 pb-1">Task Config Specification</div>
                        {task.type.includes("Canva") && (
                          <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-slate-400">
                            <div>Platform: <span className="text-slate-200">{task.platform} ({task.duration})</span></div>
                            <div>Voice Style: <span className="text-slate-200">{task.voiceStyle}</span></div>
                            <div className="col-span-2">Caption: <span className="text-slate-200">"{task.captionToUse}"</span></div>
                            <div className="col-span-2">CTA: <span className="text-slate-200">{task.finalCta}</span></div>
                            <div className="col-span-2">Instructions: <span className="text-slate-200">{task.uploadInstructions}</span></div>
                          </div>
                        )}
                        {task.type.includes("Hardware") && (
                          <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-slate-400">
                            <div>Budget: <span className="text-slate-200">£{task.customerBudget}</span></div>
                            <div>Usage: <span className="text-slate-200">{task.usageType}</span></div>
                            <div>Brand: <span className="text-slate-200">{task.preferredBrand}</span></div>
                            <div>Format: <span className="text-slate-200">{task.deviceFormat}</span></div>
                            {task.accessories && <div className="col-span-2">Accessories: <span className="text-slate-200">{task.accessories}</span></div>}
                            {task.warrantySupport && <div className="col-span-2">Warranty: <span className="text-slate-200">{task.warrantySupport}</span></div>}
                          </div>
                        )}
                      </div>
                    )}

                    {task.assetLinks && (
                      <div className="text-[9px] text-slate-400">
                        Asset Link: <a href={task.assetLinks} target="_blank" className="text-cyan-400 underline hover:text-cyan-300 break-all">{task.assetLinks}</a>
                      </div>
                    )}

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-[9px] text-slate-500 border-t border-zinc-900/50 pt-2">
                      <div>Assigned: <span className="text-slate-300 font-bold">{task.assignedWorkerEmail || 'None'}</span></div>
                      <div>Due Date: <span className="text-slate-300">{task.dueDate}</span></div>
                      <div>Est. Commission: <span className="text-cyan-400">£{parseFloat(task.estimatedCommission).toFixed(2)}</span></div>
                      <div>Payout Status: <span className="text-slate-300">{task.commissionStatus || 'estimated'}</span></div>
                    </div>

                    {/* Worker Submission Details */}
                    {task.status === 'Submitted' && (
                      <div className="p-3 bg-yellow-950/15 border border-yellow-500/25 rounded-xl space-y-2 mt-2">
                        <div className="text-yellow-400 font-bold uppercase text-[9px]">Worker Deliverable Output</div>
                        <div>Comments: <span className="text-slate-300">{task.workerComments || 'No comments'}</span></div>
                        {task.completedFileLink && (
                          <div>
                            Link: <a href={task.completedFileLink} target="_blank" className="text-cyan-400 underline hover:text-cyan-300 break-all">{task.completedFileLink}</a>
                          </div>
                        )}
                        <div className="pt-1 flex gap-2">
                          <button
                            onClick={() => {
                              setSelectedTaskForReview(task);
                              setDirectorReviewForm({ status: 'Approved', directorNotes: '' });
                            }}
                            className="px-3 py-1 bg-yellow-600 hover:bg-yellow-500 text-black font-bold uppercase rounded text-[9px] cursor-pointer"
                          >
                            Review & Approve
                          </button>
                        </div>
                      </div>
                    )}

                    {task.directorNotes && (
                      <div className="p-3 bg-zinc-900/60 border border-zinc-800 rounded-xl text-[9px] text-slate-400">
                        <strong className="text-slate-300">Director Notes: </strong> {task.directorNotes}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Column 3: Specialist Directory */}
          <div className="space-y-4">
            <div className="flex justify-between items-center border-b border-zinc-900 pb-2">
              <div className="text-white font-bold uppercase text-[11px] tracking-wider">Future Specialist Profiles</div>
              <span className="px-2 py-0.5 bg-purple-950 text-purple-400 border border-purple-500/20 rounded-[4px] text-[8px] font-bold">STAGE DEMO</span>
            </div>

            <div className="space-y-3">
              {specialistsList.map((spec) => (
                <div key={spec.id} className="p-3.5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-2.5">
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="text-white font-bold text-[10.5px]">{spec.name}</h4>
                      <div className="text-slate-500 text-[8px] mt-0.5">{spec.country} ({spec.timezone})</div>
                    </div>
                    <span className={`px-1.5 py-0.5 rounded text-[7px] font-bold uppercase ${
                      spec.status === 'active' ? 'bg-emerald-950 text-emerald-400 border border-emerald-500/20' :
                      spec.status === 'approved' ? 'bg-cyan-950 text-cyan-400 border border-cyan-500/20' :
                      'bg-yellow-950 text-yellow-400 border border-yellow-500/20'
                    }`}>
                      {spec.status}
                    </span>
                  </div>

                  <div className="space-y-1 text-[9px] text-slate-400 border-t border-zinc-900/60 pt-2">
                    <div>Category: <strong className="text-slate-300">{spec.category}</strong></div>
                    <div>Skills: <span className="text-slate-300">{spec.skills}</span></div>
                    <div>Basis: <span className="text-slate-300">{spec.basis}</span></div>
                    <div>Availability: <span className="text-slate-300">{spec.availability}</span></div>
                    {spec.portfolioLink && (
                      <div>Portfolio: <a href={spec.portfolioLink} target="_blank" className="text-purple-400 underline hover:text-purple-300 break-all">{spec.portfolioLink}</a></div>
                    )}
                  </div>

                  {spec.notes && (
                    <div className="text-[8.5px] italic text-slate-500 leading-normal bg-black/40 p-2 rounded border border-zinc-900/50">
                      {spec.notes}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Workforce Audit Logs */}
            <div className="pt-4 space-y-2">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider border-b border-zinc-900 pb-2 flex items-center gap-1.5">
                <ClipboardList size={12} className="text-cyan-400" />
                <span>Workforce OS Staging Audit Log</span>
              </div>
              <div className="bg-black/85 border border-zinc-900 rounded-xl p-3 h-48 overflow-y-auto font-mono text-[8.5px] leading-normal text-slate-400 space-y-1.5">
                {workforceAuditLogs.map((log) => (
                  <div key={log.id} className="border-b border-zinc-900/50 pb-1">
                    <span className="text-slate-500">[{new Date(log.timestamp).toLocaleTimeString()}]</span>{' '}
                    <span className="text-cyan-400 font-bold">{log.action}</span> -{' '}
                    <span className="text-slate-300 text-xxs break-words">{log.details}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Verification Reviews Section */}
        <div className="space-y-4">
          <div className="text-white font-bold uppercase text-[10.5px] tracking-wider border-b border-zinc-900 pb-2">
            Worker Verification Review Console ({verificationsList.length})
          </div>
          {verificationsList.length === 0 ? (
            <div className="p-4 border border-zinc-900 rounded-2xl text-center text-slate-500 bg-zinc-950/20">
              No verification submissions logged.
            </div>
          ) : (
            <div className="overflow-x-auto border border-zinc-900 rounded-2xl bg-zinc-950/40">
              <table className="w-full border-collapse text-left text-[10px]">
                <thead>
                  <tr className="border-b border-zinc-900 bg-black/40 text-slate-400 uppercase font-black tracking-wider">
                    <th className="p-3">Worker Name</th>
                    <th className="p-3">Email</th>
                    <th className="p-3">Role</th>
                    <th className="p-3">Timezone / Country</th>
                    <th className="p-3">Uploaded ID</th>
                    <th className="p-3">Status</th>
                    <th className="p-3 text-right">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-zinc-900">
                  {verificationsList.map((ver) => (
                    <tr key={ver.id} className="hover:bg-zinc-900/25">
                      <td className="p-3 font-bold text-white">{ver.fullName}</td>
                      <td className="p-3 text-slate-400">{ver.email}</td>
                      <td className="p-3 text-slate-300">{ver.workerRole || "N/A"}</td>
                      <td className="p-3 text-slate-400">{ver.country} ({ver.timezone || "N/A"})</td>
                      <td className="p-3 font-mono text-[9px] text-cyan-400">
                        {ver.idFile ? (
                          <div className="flex flex-col gap-0.5">
                            <span>File: {ver.idFile}</span>
                            <span className="text-slate-550 text-[8px] uppercase">Private Storage Pending</span>
                          </div>
                        ) : "None"}
                      </td>
                      <td className="p-3">
                        <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${
                          ver.status === 'Verified' ? 'bg-emerald-500/10 border border-emerald-500/30 text-emerald-400' :
                          ver.status === 'Rejected' ? 'bg-rose-500/10 border border-rose-500/30 text-rose-400' :
                          ver.status === 'Deleted' ? 'bg-zinc-800 text-slate-500' :
                          'bg-yellow-500/10 border border-yellow-500/30 text-yellow-400'
                        }`}>
                          {ver.status}
                        </span>
                      </td>
                      <td className="p-3 text-right space-x-1.5 whitespace-nowrap">
                        <button
                          onClick={() => {
                            setSelectedVerForReview(ver);
                            setVerReviewForm({ status: 'Verified', directorNotes: ver.directorNotes || '' });
                          }}
                          className="px-2 py-1 bg-cyan-900/50 hover:bg-cyan-800 text-cyan-300 rounded font-bold uppercase cursor-pointer"
                        >
                          Review
                        </button>
                        <button
                          onClick={async () => {
                            if (confirm(`Are you sure you want to delete verification documents for ${ver.email}?`)) {
                              setLoading(true);
                              try {
                                const res = await fetch("/api/admin/workforce/verification/delete", {
                                  method: "POST",
                                  headers: { "Content-Type": "application/json" },
                                  body: JSON.stringify({ verificationId: ver.id })
                                });
                                const d = await res.json();
                                if (d.success) {
                                  triggerToast("Documents deleted successfully.");
                                  syncData();
                                }
                              } catch (e) {}
                              setLoading(false);
                            }
                          }}
                          className="px-2 py-1 bg-red-950 hover:bg-red-900 text-red-400 rounded font-bold uppercase cursor-pointer"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleGenerateUtmLink = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!utmForm.campaignName) {
      triggerToast("Campaign name is required.");
      return;
    }
    
    // Map destination
    let destUrl = "https://nexoraxdigital.co.uk/";
    if (utmForm.destination === 'pricing') destUrl += "#pricing";
    if (utmForm.destination === 'contact') destUrl += "#contact";
    if (utmForm.destination === 'campaign-assets') destUrl += "campaign-assets";
    if (utmForm.destination === 'driver-ops') destUrl += "driver-ops";
    
    // Append UTM params
    const utmCampaign = utmForm.campaignName.toLowerCase().replace(/[^a-z0-9]/g, "_");
    const fullUtmUrl = `${destUrl}${destUrl.includes('?') ? '&' : '?'}utm_source=${utmForm.source}&utm_medium=${utmForm.medium}&utm_campaign=${utmCampaign}`;
    
    setLoading(true);
    try {
      const res = await fetch("/api/admin/workforce/traffic/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          campaignName: utmForm.campaignName,
          source: utmForm.source,
          medium: utmForm.medium,
          category: utmForm.category,
          destination: utmForm.destination,
          destinationUrl: fullUtmUrl
        })
      });
      const data = await res.json();
      if (data.success) {
        const domain = window.location.origin;
        const redirectUrl = `${domain}/r/${data.trackingId}`;
        setGeneratedUtmUrl(redirectUrl);
        triggerToast("Tracking link registered and generated!");
        syncData();
      }
    } catch (e) {
      triggerToast("Error registering traffic link.");
    }
    setLoading(false);
  };

  const renderTrafficTrackerSubtab = () => {
    const sc = trafficStats?.sourceCounters || { facebook: 0, linkedin: 0, tiktok: 0, whatsapp: 0, qr: 0, google_business: 0, youtube: 0, email: 0 };
    const stats = trafficStats || { totalClicks: 0, clicksToday: 0, latestClicks: [], leadsCreatedPlaceholder: 0, quoteClicksPlaceholder: 0, paymentClicksPlaceholder: 0, conversionRatePlaceholder: '0%' };

    return (
      <div className="space-y-6 text-left font-mono text-[10.5px]">
        {/* Core metrics */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="p-4 bg-zinc-950/65 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[8px] font-bold">Total Clicks</div>
            <div className="text-xl font-black text-white mt-1">{stats.totalClicks}</div>
          </div>
          <div className="p-4 bg-zinc-950/65 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[8px] font-bold">Clicks Today</div>
            <div className="text-xl font-black text-cyan-400 mt-1">{stats.clicksToday}</div>
          </div>
          <div className="p-4 bg-zinc-950/65 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[8px] font-bold">Leads Created</div>
            <div className="text-xl font-black text-emerald-400 mt-1">{stats.leadsCreatedPlaceholder}</div>
          </div>
          <div className="p-4 bg-zinc-950/65 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[8px] font-bold">Quotes/Conversions</div>
            <div className="text-xl font-black text-yellow-400 mt-1">{stats.quoteClicksPlaceholder}</div>
          </div>
          <div className="p-4 bg-zinc-950/65 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[8px] font-bold">Conversion Rate</div>
            <div className="text-xl font-black text-purple-400 mt-1">{stats.conversionRatePlaceholder}</div>
          </div>
        </div>

        {/* Source Cards */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">Facebook Clicks</div>
            <div className="text-lg font-black text-white mt-1">{sc.facebook}</div>
          </div>
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">LinkedIn Clicks</div>
            <div className="text-lg font-black text-white mt-1">{sc.linkedin}</div>
          </div>
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">TikTok Clicks</div>
            <div className="text-lg font-black text-white mt-1">{sc.tiktok}</div>
          </div>
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">WhatsApp Clicks</div>
            <div className="text-lg font-black text-white mt-1">{sc.whatsapp}</div>
          </div>
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">QR scans</div>
            <div className="text-lg font-black text-cyan-400 mt-1">{sc.qr}</div>
          </div>
          <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl">
            <div className="text-slate-500 uppercase text-[7.5px] font-black">Google Business</div>
            <div className="text-lg font-black text-white mt-1">{sc.google_business}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* UTM Generator */}
          <div className="lg:col-span-1 p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
            <div className="text-white font-bold uppercase text-[11px] border-b border-zinc-900 pb-2">UTM Link Generator</div>
            <form onSubmit={handleGenerateUtmLink} className="space-y-3">
              <div className="space-y-1">
                <label className="block text-slate-500 uppercase text-[8.5px]">Campaign Name</label>
                <input
                  type="text"
                  required
                  value={utmForm.campaignName}
                  onChange={(e) => setUtmForm({ ...utmForm, campaignName: e.target.value })}
                  className="w-full bg-black border border-zinc-850 p-2 rounded text-slate-200 focus:outline-none"
                  placeholder="e.g. QR Campaign July2026"
                />
              </div>
              <div className="space-y-1">
                <label className="block text-slate-500 uppercase text-[8.5px]">Source</label>
                <select
                  value={utmForm.source}
                  onChange={(e) => setUtmForm({ ...utmForm, source: e.target.value })}
                  className="w-full bg-black border border-zinc-850 p-2 rounded text-slate-200 focus:outline-none"
                >
                  <option value="facebook">Facebook</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="tiktok">TikTok</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="qr">QR Code</option>
                  <option value="google_business">Google Business Profile</option>
                  <option value="youtube">YouTube Shorts</option>
                  <option value="email">Email Outreach</option>
                </select>
              </div>
              <div className="space-y-1">
                <label className="block text-slate-500 uppercase text-[8.5px]">Medium</label>
                <select
                  value={utmForm.medium}
                  onChange={(e) => setUtmForm({ ...utmForm, medium: e.target.value })}
                  className="w-full bg-black border border-zinc-850 p-2 rounded text-slate-200 focus:outline-none"
                >
                  <option value="social">Social Post</option>
                  <option value="short_video">Short Video / Reels</option>
                  <option value="qr_scan">QR Scan</option>
                  <option value="profile_update">Profile Update</option>
                  <option value="direct_message">Direct Message</option>
                  <option value="email">Email Campaign</option>
                </select>
              </div>
              <div className="space-y-1">
                <label className="block text-slate-500 uppercase text-[8.5px]">Category</label>
                <select
                  value={utmForm.category}
                  onChange={(e) => setUtmForm({ ...utmForm, category: e.target.value })}
                  className="w-full bg-black border border-zinc-850 p-2 rounded text-slate-200 focus:outline-none"
                >
                  <option value="qr_campaign">QR Campaign</option>
                  <option value="driver_fleet">Driver/Courier/Fleet</option>
                  <option value="website_launchcare">Website LaunchCare</option>
                  <option value="ai_creator">AI Creator UGC</option>
                  <option value="hosting_email">Hosting/Email/Maintenance</option>
                </select>
              </div>
              <div className="space-y-1">
                <label className="block text-slate-500 uppercase text-[8.5px]">Destination Page</label>
                <select
                  value={utmForm.destination}
                  onChange={(e) => setUtmForm({ ...utmForm, destination: e.target.value })}
                  className="w-full bg-black border border-zinc-850 p-2 rounded text-slate-200 focus:outline-none"
                >
                  <option value="homepage">Homepage</option>
                  <option value="pricing">Pricing / Payment Tiers</option>
                  <option value="contact">Contact Section</option>
                  <option value="campaign-assets">Campaign Assets Index</option>
                  <option value="driver-ops">Driver Ops Systems</option>
                </select>
              </div>

              <button
                type="submit"
                className="w-full bg-purple-650 hover:bg-purple-600 text-white font-bold p-2 rounded uppercase cursor-pointer"
              >
                Register & Copy Link
              </button>
            </form>

            {generatedUtmUrl && (
              <div className="mt-3 p-3 bg-black/60 border border-zinc-900 rounded-xl space-y-2 text-left">
                <div className="text-slate-400 font-bold text-[8.5px]">GENERATED REDIRECT TRACKING LINK:</div>
                <div className="text-cyan-400 font-mono text-[9px] break-all p-1 bg-zinc-950 rounded select-all">{generatedUtmUrl}</div>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(generatedUtmUrl);
                    triggerToast("Tracking redirect URL copied!");
                  }}
                  className="px-2.5 py-1 bg-slate-900 border border-slate-800 hover:bg-slate-800 text-slate-300 font-bold rounded cursor-pointer"
                >
                  Copy Link
                </button>
              </div>
            )}
          </div>

          {/* Latest 20 clicks */}
          <div className="lg:col-span-2 p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
            <div className="text-white font-bold uppercase text-[11px] border-b border-zinc-900 pb-2">Latest 20 Clicks Logs</div>
            {stats.latestClicks.length === 0 ? (
              <div className="p-8 text-center text-slate-500 font-mono text-xs">No click events logged yet. Click a generated link to test.</div>
            ) : (
              <div className="overflow-y-auto max-h-[400px] border border-zinc-900 rounded-xl">
                <table className="w-full border-collapse text-[9.5px]">
                  <thead>
                    <tr className="border-b border-zinc-900 bg-black/40 text-slate-400 uppercase font-black text-left">
                      <th className="p-2.5">Time</th>
                      <th className="p-2.5">Campaign</th>
                      <th className="p-2.5">Source</th>
                      <th className="p-2.5">Medium</th>
                      <th className="p-2.5">Destination</th>
                      <th className="p-2.5">Referrer</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-zinc-900 text-left">
                    {stats.latestClicks.map((click: any, idx: number) => (
                      <tr key={idx} className="hover:bg-zinc-900/10 text-slate-350">
                        <td className="p-2.5 text-slate-500 font-mono text-[8.5px]">{new Date(click.timestamp).toLocaleTimeString()}</td>
                        <td className="p-2.5 font-bold text-white truncate max-w-[120px]">{click.campaignName}</td>
                        <td className="p-2.5 uppercase font-bold text-purple-400">{click.source}</td>
                        <td className="p-2.5 text-slate-400">{click.medium}</td>
                        <td className="p-2.5 text-slate-400">{click.destination}</td>
                        <td className="p-2.5 text-slate-500 truncate max-w-[100px]">{click.referrer}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderWorkforceDirectorModals = () => {
    return (
      <>
        {/* Manual Task Modal */}
        {showCreateTaskModal && (
          <div className="fixed inset-0 z-[12000] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 overflow-y-auto font-sans text-xs">
            <div className="w-full max-w-xl rounded-xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl space-y-4 my-8 max-h-[90vh] overflow-y-auto text-left">
              <div className="flex items-center justify-between border-b border-zinc-805 pb-3">
                <h3 className="font-mono text-sm font-bold text-cyan-400 uppercase tracking-wider flex items-center gap-2">
                  <ClipboardList className="h-4 w-4" /> Create Production Task
                </h3>
                <button onClick={() => setShowCreateTaskModal(false)} className="text-slate-500 hover:text-slate-300">Close</button>
              </div>

              <form onSubmit={handleCreateTask} className="space-y-4 text-left">
                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Task Title</label>
                  <input
                    type="text" required value={newTaskForm.title}
                    onChange={(e) => setNewTaskForm({ ...newTaskForm, title: e.target.value })}
                    className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500 focus:outline-none"
                    placeholder="e.g. Reputation SEO Content"
                  />
                </div>

                <div className="grid gap-4 sm:grid-cols-3">
                  <div>
                    <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Task Type</label>
                    <select
                      value={newTaskForm.type}
                      onChange={(e) => setNewTaskForm({ ...newTaskForm, type: e.target.value })}
                      className="w-full rounded-lg border border-zinc-850 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-300 focus:border-cyan-500 focus:outline-none"
                    >
                      <option value="Canva / Video Tasks">Canva / Video Tasks</option>
                      <option value="PC / Laptop / Mobile Configuration Advisor">PC / Laptop / Mobile Configuration Advisor</option>
                      <option value="SEO Tasks">SEO Tasks</option>
                      <option value="Social Media Tasks">Social Media Tasks</option>
                      <option value="Email Campaign Tasks">Email Campaign Tasks</option>
                      <option value="Website Template Tasks">Website Template Tasks</option>
                    </select>
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Target Platform</label>
                    <select
                      value={newTaskForm.platform}
                      onChange={(e) => setNewTaskForm({ ...newTaskForm, platform: e.target.value })}
                      className="w-full rounded-lg border border-zinc-850 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-300 focus:border-cyan-500 focus:outline-none"
                    >
                      <option value="TikTok">TikTok</option>
                      <option value="YouTube Shorts">YouTube Shorts</option>
                      <option value="Instagram Reels">Instagram Reels</option>
                      <option value="Facebook Reels">Facebook Reels</option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Email Outreach">Email Outreach</option>
                    </select>
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Priority</label>
                    <select
                      value={newTaskForm.priority}
                      onChange={(e) => setNewTaskForm({ ...newTaskForm, priority: e.target.value })}
                      className="w-full rounded-lg border border-zinc-850 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-300 focus:border-cyan-500 focus:outline-none"
                    >
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                  </div>
                </div>

                {/* Canva fields */}
                {newTaskForm.type.includes("Canva") && (
                  <div className="p-3.5 bg-black/45 border border-zinc-800 rounded-xl space-y-3">
                    <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest border-b border-zinc-900 pb-1">Canva / Video Settings</div>
                    <div className="grid gap-4 sm:grid-cols-3">
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Duration</label>
                        <input type="text" value={newTaskForm.duration} onChange={(e) => setNewTaskForm({ ...newTaskForm, duration: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Voice Style</label>
                        <input type="text" value={newTaskForm.voiceStyle} onChange={(e) => setNewTaskForm({ ...newTaskForm, voiceStyle: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Music Style</label>
                        <input type="text" value={newTaskForm.musicStyle} onChange={(e) => setNewTaskForm({ ...newTaskForm, musicStyle: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                    </div>
                    <div className="grid gap-4 sm:grid-cols-2">
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Captions To Use</label>
                        <input type="text" value={newTaskForm.captionToUse} onChange={(e) => setNewTaskForm({ ...newTaskForm, captionToUse: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" placeholder="e.g. Highlight terms in cyan" />
                      </div>
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Final CTA</label>
                        <input type="text" value={newTaskForm.finalCta} onChange={(e) => setNewTaskForm({ ...newTaskForm, finalCta: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" placeholder="e.g. Call freephone 0800" />
                      </div>
                    </div>
                  </div>
                )}

                {/* Hardware Advisor fields */}
                {newTaskForm.type.includes("PC / Laptop / Mobile") && (
                  <div className="p-3.5 bg-black/45 border border-zinc-800 rounded-xl space-y-3">
                    <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest border-b border-zinc-900 pb-1">Hardware Specification Settings</div>
                    <div className="grid gap-4 sm:grid-cols-3">
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Client Budget (£)</label>
                        <input type="text" value={newTaskForm.customerBudget} onChange={(e) => setNewTaskForm({ ...newTaskForm, customerBudget: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Preferred Brand</label>
                        <input type="text" value={newTaskForm.preferredBrand} onChange={(e) => setNewTaskForm({ ...newTaskForm, preferredBrand: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                      <div>
                        <label className="block font-mono text-xxs text-slate-500">Device Format</label>
                        <input type="text" value={newTaskForm.deviceFormat} onChange={(e) => setNewTaskForm({ ...newTaskForm, deviceFormat: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                      </div>
                    </div>
                    <div>
                      <label className="block font-mono text-xxs text-slate-500">Usage Type / Description</label>
                      <input type="text" value={newTaskForm.usageType} onChange={(e) => setNewTaskForm({ ...newTaskForm, usageType: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2 rounded text-white text-xs" />
                    </div>
                  </div>
                )}

                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Due Date</label>
                    <input type="date" required value={newTaskForm.dueDate} onChange={(e) => setNewTaskForm({ ...newTaskForm, dueDate: e.target.value })} className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500" />
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Commission (£)</label>
                    <input type="number" step="0.01" required value={newTaskForm.estimatedCommission} onChange={(e) => setNewTaskForm({ ...newTaskForm, estimatedCommission: e.target.value })} className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500" />
                  </div>
                </div>

                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Asset Links / Reference URLs</label>
                  <input type="text" value={newTaskForm.assetLinks} onChange={(e) => setNewTaskForm({ ...newTaskForm, assetLinks: e.target.value })} className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500" />
                </div>

                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Brief Details</label>
                  <textarea value={newTaskForm.brief} onChange={(e) => setNewTaskForm({ ...newTaskForm, brief: e.target.value })} rows={3} className="w-full rounded-lg border border-zinc-800 bg-slate-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500" />
                </div>

                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Required Deliverable Output</label>
                  <input type="text" required value={newTaskForm.requiredOutput} onChange={(e) => setNewTaskForm({ ...newTaskForm, requiredOutput: e.target.value })} className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-cyan-500" />
                </div>

                <div className="flex justify-end gap-2 border-t border-zinc-800 pt-3">
                  <button type="button" onClick={() => setShowCreateTaskModal(false)} className="rounded-lg bg-zinc-850 hover:bg-zinc-800 px-4 py-2 font-mono text-xs font-bold text-slate-400">Cancel</button>
                  <button type="submit" className="rounded-lg bg-cyan-600 hover:bg-cyan-500 px-5 py-2 font-mono text-xs font-black text-black">Dispatch Production Task</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Register Specialist Modal */}
        {showCreateSpecialistModal && (
          <div className="fixed inset-0 z-[12000] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 overflow-y-auto font-sans text-xs">
            <div className="w-full max-w-lg rounded-xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl space-y-4 my-8 max-h-[90vh] overflow-y-auto text-left">
              <div className="flex items-center justify-between border-b border-zinc-800 pb-3">
                <h3 className="font-mono text-sm font-bold text-purple-400 uppercase tracking-wider">Register Specialist Candidate</h3>
                <button onClick={() => setShowCreateSpecialistModal(false)} className="text-slate-500 hover:text-slate-300">Close</button>
              </div>
              <form onSubmit={handleCreateSpecialist} className="space-y-4 text-left">
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Name</label>
                  <input type="text" required value={newSpecialistForm.name} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, name: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                </div>
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Country</label>
                    <input type="text" required value={newSpecialistForm.country} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, country: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Timezone</label>
                    <input type="text" required value={newSpecialistForm.timezone} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, timezone: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                  </div>
                </div>
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Category</label>
                    <select value={newSpecialistForm.category} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, category: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs">
                      <option value="Canva / CapCut Video Creators">Canva / CapCut Video Creators</option>
                      <option value="Web Developers">Web Developers</option>
                      <option value="AI Automation Specialists">AI Automation Specialists</option>
                      <option value="SEO Specialists">SEO Specialists</option>
                      <option value="Infrastructure Security Auditing">Infrastructure Security Auditing</option>
                    </select>
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Status</label>
                    <select value={newSpecialistForm.status} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, status: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs">
                      <option value="candidate">candidate</option>
                      <option value="approved">approved</option>
                      <option value="active">active</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Skills</label>
                  <input type="text" required value={newSpecialistForm.skills} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, skills: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                </div>
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Payment Basis</label>
                    <input type="text" required value={newSpecialistForm.basis} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, basis: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                  </div>
                  <div>
                    <label className="block font-mono text-xxs uppercase text-slate-500">Availability</label>
                    <input type="text" required value={newSpecialistForm.availability} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, availability: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                  </div>
                </div>
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Portfolio Link</label>
                  <input type="text" value={newSpecialistForm.portfolioLink} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, portfolioLink: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                </div>
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Director Notes</label>
                  <textarea value={newSpecialistForm.notes} onChange={(e) => setNewSpecialistForm({ ...newSpecialistForm, notes: e.target.value })} rows={2} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" />
                </div>
                <div className="flex justify-end gap-2 border-t border-zinc-800 pt-3">
                  <button type="button" onClick={() => setShowCreateSpecialistModal(false)} className="rounded-lg bg-zinc-850 hover:bg-zinc-800 px-4 py-2 font-mono text-xs font-bold text-slate-400">Cancel</button>
                  <button type="submit" className="rounded-lg bg-purple-650 hover:bg-purple-600 px-5 py-2 font-mono text-xs font-black text-white">Save Profile</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Task Review Modal */}
        {selectedTaskForReview && (
          <div className="fixed inset-0 z-[12000] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 overflow-y-auto font-sans text-xs">
            <div className="w-full max-w-md rounded-xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl space-y-4 my-8 text-left">
              <div className="flex items-center justify-between border-b border-zinc-800 pb-3">
                <h3 className="font-mono text-sm font-bold text-yellow-400 uppercase tracking-wider">Review Task Submission</h3>
                <button onClick={() => setSelectedTaskForReview(null)} className="text-slate-500 hover:text-slate-300">Close</button>
              </div>
              <form onSubmit={handleReviewSubmit} className="space-y-4 text-left">
                <div className="bg-black/55 p-3 rounded-lg space-y-1.5">
                  <div>Task: <strong className="text-white">{selectedTaskForReview.title}</strong></div>
                  <div>Worker Comments: <span className="text-slate-300">{selectedTaskForReview.workerComments || 'None'}</span></div>
                  {selectedTaskForReview.completedFileLink && (
                    <div>File: <a href={selectedTaskForReview.completedFileLink} target="_blank" className="text-cyan-400 underline break-all">{selectedTaskForReview.completedFileLink}</a></div>
                  )}
                </div>
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Review Outcome</label>
                  <select value={directorReviewForm.status} onChange={(e) => setDirectorReviewForm({ ...directorReviewForm, status: e.target.value })} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs">
                    <option value="Approved">Approved</option>
                    <option value="Needs Changes">Needs Changes</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </div>
                <div>
                  <label className="block font-mono text-xxs uppercase text-slate-500">Director Feedback / Notes</label>
                  <textarea required value={directorReviewForm.directorNotes} onChange={(e) => setDirectorReviewForm({ ...directorReviewForm, directorNotes: e.target.value })} rows={3} className="w-full bg-zinc-950 border border-zinc-850 p-2.5 rounded text-white text-xs" placeholder="Comments on corrections required or approval confirmation..." />
                </div>
                <div className="flex justify-end gap-2 border-t border-zinc-800 pt-3">
                  <button type="button" onClick={() => setSelectedTaskForReview(null)} className="rounded-lg bg-zinc-850 hover:bg-zinc-800 px-4 py-2 font-mono text-xs font-bold text-slate-400">Cancel</button>
                  <button type="submit" className="rounded-lg bg-yellow-600 hover:bg-yellow-500 px-5 py-2 font-mono text-xs font-black text-black">Submit Review</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderWorkerProductionTasks = () => {
    const myTasks = productionTasks.filter(t => t.assignedWorkerEmail === currentProfile?.email);
    const availableTasks = productionTasks.filter(t => t.status === 'Available');

    return (
      <div className="space-y-6 text-left text-[10.5px] font-mono">
        {/* Available Tasks Section */}
        <div className="space-y-4">
          <div className="text-white font-bold uppercase text-[10.5px] tracking-wider border-b border-zinc-900 pb-2">
            Available Production Tasks ({availableTasks.length})
          </div>
          {availableTasks.length === 0 ? (
            <div className="p-4 border border-zinc-900 rounded-2xl text-center text-slate-500 bg-zinc-950/20">
              No available tasks to claim at this moment. Check back later.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {availableTasks.map(task => (
                <div key={task.id} className="p-4 bg-zinc-950/60 border border-zinc-900 hover:border-cyan-500/25 rounded-2xl space-y-3 flex flex-col justify-between">
                  <div className="space-y-2">
                    <div className="flex justify-between items-start">
                      <span className="px-2 py-0.5 bg-slate-900 text-slate-400 rounded text-[8px] font-bold uppercase">{task.type}</span>
                      <span className="text-cyan-400 font-bold">Est: £{parseFloat(task.estimatedCommission).toFixed(2)}</span>
                    </div>
                    <h4 className="text-white font-bold text-xs">{task.title}</h4>
                    <p className="text-slate-350 leading-relaxed text-[10px]">{task.brief}</p>
                    
                    {/* Instructions templates preview */}
                    {task.captionToUse && (
                      <div className="p-2 bg-black/45 border border-zinc-900/60 rounded-xl space-y-1 text-[8.5px] text-slate-400">
                        <div>Caption: <span className="text-slate-200">"{task.captionToUse}"</span></div>
                        <div>CTA: <span className="text-slate-200">{task.finalCta}</span></div>
                      </div>
                    )}
                    {task.customerBudget && (
                      <div className="p-2 bg-black/45 border border-zinc-900/60 rounded-xl space-y-1 text-[8.5px] text-slate-400">
                        <div>Budget: <span className="text-slate-200">£{task.customerBudget}</span></div>
                        <div>Usage: <span className="text-slate-200">{task.usageType}</span></div>
                      </div>
                    )}
                  </div>
                  
                  <div className="pt-3 border-t border-zinc-900/65 flex justify-between items-center">
                    <span className="text-slate-500 text-[8.5px]">Due: {task.dueDate}</span>
                    <button
                      onClick={() => handleClaimTask(task.id)}
                      className="px-3.5 py-1.5 bg-cyan-900/50 hover:bg-cyan-800/60 text-cyan-300 font-bold uppercase rounded-lg cursor-pointer"
                    >
                      Claim Task
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Assigned Tasks Section */}
        <div className="space-y-4 pt-4">
          <div className="text-white font-bold uppercase text-[10.5px] tracking-wider border-b border-zinc-900 pb-2">
            My Assigned Tasks ({myTasks.length})
          </div>
          {myTasks.length === 0 ? (
            <div className="p-4 border border-zinc-900 rounded-2xl text-center text-slate-500 bg-zinc-950/20">
              You haven't claimed or been assigned any tasks yet.
            </div>
          ) : (
            <div className="space-y-3">
              {myTasks.map(task => (
                <div key={task.id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-3">
                  <div className="flex justify-between items-start flex-wrap gap-2">
                    <div>
                      <span className="px-2 py-0.5 bg-slate-900 text-slate-400 rounded text-[8px] font-bold uppercase mr-2">{task.type}</span>
                      <h4 className="text-white font-bold text-xs mt-1">{task.title}</h4>
                    </div>
                    <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${
                      task.status === 'Submitted' ? 'bg-yellow-950 text-yellow-400 border border-yellow-500/20' :
                      task.status === 'Approved' ? 'bg-emerald-950 text-emerald-400 border border-emerald-500/20' :
                      task.status === 'Needs Changes' ? 'bg-red-950 text-red-400 border border-red-500/20 animate-pulse' :
                      'bg-purple-950 text-purple-400 border border-purple-500/20'
                    }`}>
                      {task.status}
                    </span>
                  </div>

                  <p className="text-slate-300 text-[10px] leading-relaxed">{task.brief}</p>

                  {/* Config parameters */}
                  {task.captionToUse && (
                    <div className="p-3 bg-black/45 border border-zinc-900/60 rounded-xl space-y-1.5 text-[9px] text-slate-400">
                      <div className="text-slate-550 font-bold uppercase border-b border-zinc-900/35 pb-1">Task Config Details</div>
                      <div className="grid grid-cols-2 gap-2">
                        <div>Platform: <span className="text-slate-200">{task.platform} ({task.duration})</span></div>
                        <div>Voice: <span className="text-slate-200">{task.voiceStyle}</span></div>
                        <div className="col-span-2">Caption: <span className="text-slate-200">"{task.captionToUse}"</span></div>
                        <div className="col-span-2">CTA: <span className="text-slate-200">{task.finalCta}</span></div>
                        <div className="col-span-2">Staging Upload Instructions: <span className="text-slate-200">{task.uploadInstructions}</span></div>
                      </div>
                    </div>
                  )}

                  {task.customerBudget && (
                    <div className="p-3 bg-black/45 border border-zinc-900/60 rounded-xl space-y-1.5 text-[9px] text-slate-400">
                      <div className="text-slate-550 font-bold uppercase border-b border-zinc-900/35 pb-1">Hardware Config Specification</div>
                      <div className="grid grid-cols-2 gap-2">
                        <div>Budget Limit: <span className="text-slate-200">£{task.customerBudget}</span></div>
                        <div>Brand: <span className="text-slate-200">{task.preferredBrand}</span></div>
                        <div>Format: <span className="text-slate-200">{task.deviceFormat}</span></div>
                        <div>Warranty: <span className="text-slate-200">{task.warrantySupport}</span></div>
                        {task.accessories && <div className="col-span-2">Accessories: <span className="text-slate-200">{task.accessories}</span></div>}
                      </div>
                    </div>
                  )}

                  {task.assetLinks && (
                    <div className="text-[9px] text-slate-400">
                      Asset Link: <a href={task.assetLinks} target="_blank" className="text-cyan-400 underline hover:text-cyan-300 break-all">{task.assetLinks}</a>
                    </div>
                  )}

                  {task.directorNotes && (
                    <div className="p-3 bg-zinc-900/40 border border-zinc-800 rounded-xl text-[9px] text-slate-400">
                      <strong className="text-slate-300">Feedback from Director:</strong> {task.directorNotes}
                    </div>
                  )}

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-[9px] text-slate-500 border-t border-zinc-900/50 pt-2.5">
                    <div>Due Date: <span className="text-slate-300">{task.dueDate}</span></div>
                    <div>Est. Commission: <span className="text-cyan-400 font-bold">£{parseFloat(task.estimatedCommission).toFixed(2)}</span></div>
                    <div>Status: <span className="text-slate-300 uppercase">{task.commissionStatus || 'estimated'}</span></div>
                  </div>

                  {/* Submission actions */}
                  {(task.status === 'Assigned' || task.status === 'In Progress' || task.status === 'Needs Changes') && (
                    <div className="pt-2">
                      <button
                        onClick={() => setSelectedTaskForDetails(task)}
                        className="px-3.5 py-1.5 bg-purple-900/40 border border-purple-500/30 hover:bg-purple-800/40 text-purple-300 font-bold uppercase rounded-lg cursor-pointer"
                      >
                        Submit Completed Work
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderWorkforceWorkerModals = () => {
    return (
      <>
        {selectedTaskForDetails && (
          <div className="fixed inset-0 z-[12000] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 overflow-y-auto font-sans text-xs">
            <div className="w-full max-w-md rounded-xl border border-zinc-800 bg-zinc-900 p-6 shadow-2xl space-y-4 my-8 text-left">
              <div className="flex items-center justify-between border-b border-zinc-805 pb-3">
                <h3 className="font-mono text-sm font-bold text-purple-400 uppercase tracking-wider">Submit Completed Work</h3>
                <button onClick={() => setSelectedTaskForDetails(null)} className="text-slate-500 hover:text-slate-300">Close</button>
              </div>

              <form onSubmit={handleWorkerSubmit} className="space-y-4 text-left">
                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Deliverable Link / URL</label>
                  <input
                    type="text"
                    required
                    value={workerSubmitForm.completedFileLink}
                    onChange={(e) => setWorkerSubmitForm({ ...workerSubmitForm, completedFileLink: e.target.value })}
                    className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-purple-500 focus:outline-none"
                    placeholder="e.g. https://canva.com/design/... or Google Drive link"
                  />
                </div>

                <div className="space-y-1">
                  <label className="block font-mono text-xxs uppercase tracking-wider text-slate-500">Comments / Notes for Director</label>
                  <textarea
                    required
                    value={workerSubmitForm.workerComments}
                    onChange={(e) => setWorkerSubmitForm({ ...workerSubmitForm, workerComments: e.target.value })}
                    rows={3}
                    className="w-full rounded-lg border border-zinc-800 bg-zinc-950/80 p-2.5 font-mono text-xs text-slate-200 focus:border-purple-500 focus:outline-none"
                    placeholder="Enter any comments, captions checked, or confirmation of build compliance..."
                  />
                </div>

                <div className="flex justify-end gap-2 border-t border-zinc-805 pt-3">
                  <button type="button" onClick={() => setSelectedTaskForDetails(null)} className="rounded-lg bg-zinc-850 hover:bg-zinc-800 px-4 py-2 font-mono text-xs font-bold text-slate-400">Cancel</button>
                  <button type="submit" className="rounded-lg bg-purple-650 hover:bg-purple-600 px-5 py-2 font-mono text-xs font-black text-white">Submit Work Deliverables</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  };


  const handleModifyWorkerStatus = async (workerId: string, status: string) => {
    try {
      const res = await fetch(`/api/operator/admin/workers/${workerId}/status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Worker status updated to ${status}.`);
        const opsRes = await fetch('/api/operator/admin/operators');
        const opsData = await opsRes.json();
        if (opsData.success) setOperatorsList(opsData.operators);
      } else {
        triggerToast(data.error || "Failed to change status.");
      }
    } catch (err) {
      triggerToast("Error updating worker status.");
    }
  };

  const handleOnboardingSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreementAccepted || !rulesAccepted) {
      triggerToast("You must accept both agreements and workspace rules to proceed.");
      return;
    }

    try {
      const res = await fetch('/api/operator/onboard', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...onboardingForm, rules_accepted: true })
      });
      const data = await res.json();
      if (data.success) {
        setCredentials({ email: onboardingForm.email, password: '' });
        setIsAuthenticated(true);
        setViewMode('console');
        triggerToast("Onboarding completed successfully. Redirecting...");
        setTimeout(() => {
          window.history.pushState({}, '', '/operator-console');
          syncData();
        }, 1000);
      } else {
        triggerToast(data.error || "Onboarding failed.");
      }
    } catch (err) {
      triggerToast("Network error during onboarding.");
    }
  };

  const handleLoginCodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/operator/login-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginForm)
      });
      const data = await res.json();
      if (data.success) {
        setCredentials({ email: loginForm.email, password: '' });
        setIsAuthenticated(true);
        setViewMode('console');
        triggerToast("Login verified. Redirecting...");
        setTimeout(() => {
          window.history.pushState({}, '', '/operator-console');
          syncData();
        }, 1000);
      } else {
        triggerToast(data.error || "Invalid login credentials.");
      }
    } catch (err) {
      triggerToast("Network error during login.");
    }
  };

  // POST Live Preview Update
  const handleSavePreview = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editingPreviewId) return;
    try {
      const res = await fetch(`/api/operator/previews/${editingPreviewId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...previewForm,
          completionPercentage: parseInt(previewForm.completionPercentage) || 0,
          status: 'Active Draft'
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Live Preview Draft saved.");
        setEditingPreviewId(null);
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to save preview draft.");
    }
  };

  // POST Preview submit review checklist
  const handleSubmitPreviewReview = async (previewId: string) => {
    try {
      const res = await fetch(`/api/operator/previews/${previewId}/submit-review`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ designChecklist: designReviewChecklist })
      });
      const data = await res.json();
      if (data.success) {
        setAiReviewFeedback(data.advisorFeedback);
        triggerToast(`Review Evaluated: ${data.status}`);
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to submit design review.");
    }
  };

  // Lead Finder Search with Auto-Save
  const handleLeadSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadSearchForm.keyword || !leadSearchForm.location) {
      triggerToast("Keyword and Location are required.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/operator/lead-search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(leadSearchForm)
      });
      const data = await res.json();
      if (data.success) {
        setSearchedLeads(data.leads);
        triggerToast("Search results saved to your opportunity queue.");
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to run lead search.");
    } finally {
      setLoading(false);
    }
  };

  // Claim Lead Route Connect
  const handleClaimOpportunity = async (oppId: string) => {
    try {
      const res = await fetch(`/api/operator/leads/${oppId}/claim`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Lead successfully claimed.");
        setSelectedLeadForChecklist(data.opportunity);
        setLeadChecklist({
          reviewedName: true,
          checkedWebsite: !!data.opportunity.websiteUrl,
          checkedSocial: !!data.opportunity.socialUrl,
          checkedReviews: !!data.opportunity.reviewScore,
          opportunityTypeSelected: false,
          problemNoticed: false,
          ranAdvisorAnalysis: false,
          selectedSuggestedOffer: false
        });
        syncData();
      } else {
        triggerToast(data.error || "Claim failed.");
      }
    } catch (err) {
      triggerToast("Failed to claim lead.");
    }
  };

  // Run Advisor analysis on a specific lead
  const handleAnalyseLeadChecklist = async (oppId: string) => {
    setLoading(true);
    try {
      const res = await fetch(`/api/operator/leads/${oppId}/analyse`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
      });
      const data = await res.json();
      if (data.success) {
        setAdvisorAnalysis(data.opportunity.advisorAnalysis);
        setSelectedLeadForChecklist(data.opportunity);
        setLeadChecklist(prev => ({ ...prev, ranAdvisorAnalysis: true }));
        triggerToast("Advisor analysis retrieved successfully.");
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to retrieve analysis.");
    } finally {
      setLoading(false);
    }
  };

  // Mark lead complete (Done)
  const handleMarkLeadDone = async (oppId: string) => {
    try {
      const res = await fetch(`/api/operator/leads/${oppId}/complete`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Lead moved to completed queue.");
        setSelectedLeadForChecklist(null);
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to complete lead.");
    }
  };

  // Mark lead not suitable
  const handleMarkLeadNotSuitable = async (oppId: string) => {
    try {
      const res = await fetch(`/api/operator/leads/${oppId}/not-suitable`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Lead marked as not suitable.");
        setSelectedLeadForChecklist(null);
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to mark lead.");
    }
  };

  // Reopen completed lead (Director/Admin only)
  const handleReopenLead = async (oppId: string) => {
    try {
      const res = await fetch(`/api/operator/leads/${oppId}/reopen`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        triggerToast("Lead reopened successfully.");
        syncData();
      } else {
        triggerToast(data.error || "Action unauthorized.");
      }
    } catch (err) {
      triggerToast("Failed to reopen lead.");
    }
  };

  // Manual entry opportunity
  const handleAddOpportunityLead = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!leadFinderForm.businessName) {
      triggerToast("Business Name is required.");
      return;
    }
    try {
      const res = await fetch('/api/operator/opportunities', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          businessName: leadFinderForm.businessName,
          websiteUrl: leadFinderForm.websiteUrl,
          socialUrl: leadFinderForm.socialUrl,
          phone: leadFinderForm.phone,
          publicEmail: leadFinderForm.publicEmail,
          location: `${leadFinderForm.location} (${leadFinderForm.industry})`,
          notes: leadFinderForm.notes,
          source: 'Lead Finder Manual Entry'
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Manual opportunity added.");
        setLeadFinderForm({ businessName: '', industry: '', location: '', websiteUrl: '', socialUrl: '', phone: '', publicEmail: '', reviewScore: '4.0', reviewCount: '12', searchIntent: 'Website opportunity', notes: '' });
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to save opportunity.");
    }
  };

  // Business Opportunity Analyzer Form
  const handleAnalyseBusiness = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!analyzerForm.businessName) {
      triggerToast("Please select or enter a business name.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/operator/business-analyse', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(analyzerForm)
      });
      const data = await res.json();
      if (data.success) {
        setAdvisorAnalysis(data.opportunity.advisorAnalysis);
        triggerToast("NexoraX Advisor Analysis complete.");
        syncData();
      }
    } catch (err) {
      triggerToast("Evaluation request failed.");
    } finally {
      setLoading(false);
    }
  };

  // Website checker rules
  const handleCalculateChecker = (e: React.FormEvent) => {
    e.preventDefault();
    const exists = checkerForm.websiteExists === 'Yes';
    const mobile = checkerForm.mobileQuality;

    let opportunityScore = 'Medium';
    let suggestedOffer = 'LaunchCare Premier £50';
    let reason = 'Website mobile layout or CTA capture could be improved.';

    if (!exists) {
      opportunityScore = 'High';
      suggestedOffer = 'LaunchCare Starter £25';
      reason = 'Strong reviews but no custom domain present.';
    } else if (mobile === 'Poor') {
      opportunityScore = 'High';
      suggestedOffer = 'LaunchCare Premier £50 / Pro £99';
      reason = 'Poor mobile viewport styling detected. High bounce risk.';
    }

    setCheckerResult({ opportunityScore, suggestedOffer, reason });
    triggerToast("Calculated recommendation checker match.");
  };

  // Outreach Draft Prep
  const handleGenerateOutreach = (e: React.FormEvent) => {
    e.preventDefault();
    if (!outreachForm.businessName) {
      triggerToast("Please select or enter a business name.");
      return;
    }
    
    const draftText = `Subject: Proposal for ${outreachForm.businessName} - NexoraX Digital Systems

Dear Management Team,

We recently reviewed your digital footprint. We noticed some areas of improvement:
- Pain point: ${outreachForm.painPoint || 'Mobile optimization and conversion rates'}
- Suggested improvement: ${outreachForm.suggestedImprovement || 'A fast-loading checkout landing page'}

We would love to present our ${outreachForm.outreachAngle || 'LaunchCare Premier'} package to help streamline your customer acquisition.

Best regards,
NexoraX Digital LTD Team

---
Opt-out line: If this is not relevant, reply "No thanks" and we will not contact you again.
Contact coordinates:
sales@nexoraxdigital.co.uk | info@nexoraxdigital.co.uk | support@nexoraxdigital.co.uk | 08000 622827`;

    setGeneratedOutreachText(draftText);
    triggerToast("Generated Outreach Draft.");
  };

  const handleSaveOutreach = async () => {
    if (!outreachForm.businessName || !generatedOutreachText) {
      triggerToast("Outreach text must be generated first.");
      return;
    }
    try {
      const res = await fetch('/api/operator/outreach-drafts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          businessName: outreachForm.businessName,
          recipientEmail: outreachForm.recipientEmail || 'info@partner-domain.co.uk',
          outreachAngle: outreachForm.outreachAngle,
          messageBody: generatedOutreachText,
          status: 'Ready for Review'
        })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Outreach Draft submitted to Director queue.");
        setOutreachForm({ selectedOppId: '', businessName: '', outreachAngle: 'Introduce LaunchCare professional website setup and custom branding.', painPoint: '', suggestedImprovement: '', messageTone: 'Professional & Direct', notes: '', recipientEmail: '' });
        setGeneratedOutreachText('');
        syncData();
      }
    } catch (err) {
      triggerToast("Outreach draft save failed.");
    }
  };

  // Product analyzer
  const handleAddProductResearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!productResearchForm.productName) {
      triggerToast("Product/Idea Name is required.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/operator/product-analyse', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(productResearchForm)
      });
      const data = await res.json();
      if (data.success) {
        setProductAnalysisResult(data.productResearch.analysis);
        triggerToast("Product link analyzed with Advisor.");
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to analyze product link.");
    } finally {
      setLoading(false);
    }
  };

  // Product suggestions
  const handleGetProductSuggestions = async () => {
    try {
      const res = await fetch('/api/operator/product-research/suggestions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productCategory: productResearchForm.category,
          trendIdea: productResearchForm.productName || 'trending ecom widget'
        })
      });
      const data = await res.json();
      if (data.success) {
        setProductSuggestions(data.suggestions);
        triggerToast("Retrieved product suggestions.");
      }
    } catch (err) {
      triggerToast("Suggestions retrieval failed.");
    }
  };

  // Next Available Task start
  const handleStartNextTask = async (taskName: string) => {
    try {
      const res = await fetch('/api/operator/next-task/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ taskName })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast(`Next Task Activated: ${taskName}. Go to Mission Board!`);
        syncData();
        setConsoleTab('missions');
      }
    } catch (err) {
      triggerToast("Activation failed.");
    }
  };

  // Start Task
  const handleStartTask = async (id: string) => {
    try {
      const res = await fetch(`/api/operator/build-tasks/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'In Progress' })
      });
      const data = await res.json();
      if (data.success) {
        triggerToast("Task marked as In Progress.");
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to start task.");
    }
  };

  // Submit suggestion
  const handleSuggestImprovement = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!suggestionForm.title || !suggestionForm.description) {
      triggerToast("Title and Description are required.");
      return;
    }
    try {
      const res = await fetch('/api/operator/suggestions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(suggestionForm)
      });
      const data = await res.json();
      if (data.success) {
        setAdvisorResponse(data.suggestion.advisorResponse);
        setSuggestionForm({ title: '', type: 'Design Improvement', description: '', whyItHelps: '', relatedTask: '', estimatedValue: 'Medium', operatorNotes: '' });
        triggerToast("Suggestion logged. Advisor response retrieved.");
        syncData();
      }
    } catch (err) {
      triggerToast("Failed to log suggestion.");
    }
  };

  // Safe Logout Confirmation Screen
  if (loggedOut) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-left font-sans">
        <div className="w-full max-w-md glass-panel border border-purple-500/35 p-8 rounded-3xl bg-zinc-950/80 shadow-[0_0_50px_rgba(168,85,247,0.15)] space-y-6 text-center">
          <div className="w-12 h-12 bg-purple-500/10 border border-purple-500/30 rounded-2xl flex items-center justify-center mx-auto text-purple-400">
            <CheckCircle size={22} />
          </div>
          <h1 className="text-xl font-black uppercase text-white tracking-tight pt-2">
            Safe Exit Complete
          </h1>
          <p className="text-xs text-slate-300 font-mono leading-relaxed">
            You have safely logged out of NexoraX Remote Operator Portal. <br />
            Your workspace changes and active queue states have been saved.
          </p>
          <button onClick={() => { setLoggedOut(false); setIsAuthenticated(false); setAuthStep('login'); }} className="w-full py-3 bg-gradient-to-r from-purple-650 to-fuchsia-600 hover:opacity-95 text-white font-black text-[10px] uppercase tracking-widest rounded-xl transition-all cursor-pointer shadow-[0_0_15px_rgba(168,85,247,0.2)]">
            Login Again
          </button>
        </div>
      </div>
    );
  }

  // Onboarding View Screen
  if (viewMode === 'onboarding') {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-left font-sans">
        <div className="w-full max-w-lg glass-panel border border-purple-500/35 p-8 rounded-3xl bg-zinc-950/80 shadow-[0_0_50px_rgba(168,85,247,0.15)] space-y-6">
          <div className="text-center space-y-2">
            <div className="w-12 h-12 bg-purple-500/10 border border-purple-500/30 rounded-2xl flex items-center justify-center mx-auto text-purple-400">
              <UserCheck size={22} className="animate-pulse" />
            </div>
            <h1 className="text-xl font-black uppercase text-white tracking-tight pt-2">
              NexoraX Operator Onboarding
            </h1>
            <p className="text-xs text-slate-500 font-mono">
              WORKER REGISTRATION • STAGING NODE INITIALIZATION
            </p>
          </div>

          <form onSubmit={handleOnboardingSubmit} className="space-y-4 font-mono text-xs text-slate-300">
            <div className="space-y-1">
              <label className="text-[10px] uppercase font-bold text-slate-400">Unique Invite Code</label>
              <input 
                type="text" 
                value={onboardingForm.invite_code}
                onChange={(e) => setOnboardingForm({ ...onboardingForm, invite_code: e.target.value.trim().toUpperCase() })}
                placeholder="e.g. INV-XXXXXX"
                className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                required
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Full Name</label>
                <input 
                  type="text" 
                  value={onboardingForm.name}
                  onChange={(e) => setOnboardingForm({ ...onboardingForm, name: e.target.value })}
                  placeholder="John Doe"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                  required
                />
              </div>
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Email Address</label>
                <input 
                  type="email" 
                  value={onboardingForm.email}
                  onChange={(e) => setOnboardingForm({ ...onboardingForm, email: e.target.value })}
                  placeholder="john@example.com"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                  required
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Phone (Optional)</label>
                <input 
                  type="text" 
                  value={onboardingForm.phone}
                  onChange={(e) => setOnboardingForm({ ...onboardingForm, phone: e.target.value })}
                  placeholder="+44 7123 456789"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                />
              </div>
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Country/Location (Optional)</label>
                <input 
                  type="text" 
                  value={onboardingForm.location}
                  onChange={(e) => setOnboardingForm({ ...onboardingForm, location: e.target.value })}
                  placeholder="United Kingdom"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                />
              </div>
            </div>

            {/* Rules and Agreement boxes */}
            <div className="p-4 bg-purple-950/15 border border-purple-500/20 rounded-2xl space-y-3 leading-relaxed text-slate-400 text-[10.5px]">
              <div className="text-white font-bold uppercase text-[10px]">Remote Worker Security Rules:</div>
              <div className="space-y-2">
                <label className="flex items-start gap-2 cursor-pointer">
                  <input type="checkbox" checked={rulesAccepted} onChange={(e) => setRulesAccepted(e.target.checked)} className="mt-0.5 rounded border-zinc-800 text-purple-650 focus:ring-0" required />
                  <span>I agree to follow the remote workforce guidelines. I will not seek admin/server/source credentials, live outreach, or self-approvals.</span>
                </label>
                <label className="flex items-start gap-2 cursor-pointer">
                  <input type="checkbox" checked={agreementAccepted} onChange={(e) => setAgreementAccepted(e.target.checked)} className="mt-0.5 rounded border-zinc-800 text-purple-650 focus:ring-0" required />
                  <span>I understand that commissions are subject to Director validation and actual customer payment clearances.</span>
                </label>
              </div>
            </div>

            <button type="submit" className="w-full py-3 bg-gradient-to-r from-purple-650 to-fuchsia-600 hover:opacity-95 text-white font-black text-[10px] uppercase tracking-widest rounded-xl transition-all cursor-pointer shadow-[0_0_15px_rgba(168,85,247,0.2)]">
              Complete Onboarding & Access Console
            </button>
            <div className="text-center pt-2">
              <button type="button" onClick={() => setViewMode('login')} className="text-[10px] text-purple-400 hover:text-purple-300 underline cursor-pointer">
                Already registered? Log in here
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Login View Screen
  if (viewMode === 'login') {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-left font-sans">
        <div className="w-full max-w-md glass-panel border border-purple-500/35 p-8 rounded-3xl bg-zinc-950/80 shadow-[0_0_50px_rgba(168,85,247,0.15)] space-y-6">
          <div className="text-center space-y-2">
            <div className="w-12 h-12 bg-purple-500/10 border border-purple-500/30 rounded-2xl flex items-center justify-center mx-auto text-purple-400">
              <Key size={22} className="animate-pulse" />
            </div>
            <h1 className="text-xl font-black uppercase text-white tracking-tight pt-2">
              NexoraX Operator Secure Login
            </h1>
            <p className="text-xs text-slate-500 font-mono">
              WORKER GATEWAY • SESSION STABILIZATION
            </p>
          </div>

          <form onSubmit={handleLoginCodeSubmit} className="space-y-4 font-mono text-xs text-slate-300">
            <div className="space-y-1">
              <label className="text-[10px] uppercase font-bold text-slate-400">Email Address</label>
              <input 
                type="email" 
                value={loginForm.email}
                onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value.toLowerCase().trim() })}
                placeholder="name@example.com"
                className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] uppercase font-bold text-slate-400">Invite Code or Operator Code</label>
              <input 
                type="text" 
                value={loginForm.invite_code}
                onChange={(e) => setLoginForm({ ...loginForm, invite_code: e.target.value.trim().toUpperCase() })}
                placeholder="INV-XXXXXX or OP-XXXX"
                className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                required
              />
            </div>
            <button type="submit" className="w-full py-3 bg-gradient-to-r from-purple-650 to-fuchsia-600 hover:opacity-95 text-white font-black text-[10px] uppercase tracking-widest rounded-xl transition-all cursor-pointer shadow-[0_0_15px_rgba(168,85,247,0.2)]">
              Verify Credentials & Access Node
            </button>
            <div className="text-center pt-2">
              <button type="button" onClick={() => setViewMode('onboarding')} className="text-[10px] text-purple-400 hover:text-purple-300 underline cursor-pointer">
                First time? Register with Invite Code
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Secure MFA Login Screen
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-6 text-left font-sans">
        <div className="w-full max-w-md glass-panel border border-purple-500/35 p-8 rounded-3xl bg-zinc-950/80 shadow-[0_0_50px_rgba(168,85,247,0.15)] space-y-6">
          <div className="text-center space-y-2">
            <div className="w-12 h-12 bg-purple-500/10 border border-purple-500/30 rounded-2xl flex items-center justify-center mx-auto text-purple-400">
              <Lock size={22} className="animate-pulse" />
            </div>
            <h1 className="text-xl font-black uppercase text-white tracking-tight pt-2">
              NexoraX Remote Operator Portal
            </h1>
            <p className="text-xs text-slate-500 font-mono">
              STAFF GATEWAY • STAGING SECURE WORKSPACE
            </p>
          </div>

          {authStep === 'login' ? (
            <form onSubmit={handleLogin} className="space-y-4 font-mono text-xs text-slate-300">
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Corporate Email</label>
                <input 
                  type="email" 
                  value={credentials.email}
                  onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                  placeholder="name@nexoraxdigital.co.uk"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                  required
                />
              </div>
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Password</label>
                <input 
                  type="password" 
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  placeholder="••••••••"
                  className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none focus:border-purple-500"
                  required
                />
              </div>
              <button type="submit" className="w-full py-3 bg-gradient-to-r from-purple-650 to-fuchsia-600 hover:opacity-95 text-white font-black text-[10px] uppercase tracking-widest rounded-xl transition-all cursor-pointer shadow-[0_0_15px_rgba(168,85,247,0.2)]">
                Dispatch MFA Code
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyMfa} className="space-y-4 font-mono text-xs text-slate-300">
              <div className="p-3.5 bg-purple-950/20 border border-purple-500/20 rounded-xl text-[10.5px] leading-relaxed text-purple-300">
                ⚠️ **Email Verification Required**: Enter the 6-digit verification code.
              </div>
              <div className="space-y-1">
                <label className="text-[10px] uppercase font-bold text-slate-400">Verification Code</label>
                <input type="text" maxLength={6} value={mfaCode} onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, ''))} placeholder="e.g. 123456" className="w-full bg-black border border-zinc-800 p-3 rounded-xl text-white outline-none text-center tracking-widest font-black text-sm focus:border-purple-500" required />
              </div>
              <button type="submit" className="w-full py-3 bg-gradient-to-r from-cyan-500/30 to-purple-500/30 border border-cyan-500/40 text-cyan-400 font-black uppercase tracking-widest rounded-xl cursor-pointer">
                Access Operator Console
              </button>
            </form>
          )}

          <div className="flex justify-between items-center text-[10px] font-mono border-t border-zinc-900 pt-4">
            <button onClick={() => setViewMode('onboarding')} className="text-purple-400 hover:text-purple-300 cursor-pointer">Onboard Helper</button>
            <button onClick={() => setViewMode('login')} className="text-purple-400 hover:text-purple-300 cursor-pointer">Helper Login</button>
          </div>
        </div>
      </div>
    );
  }

  if (isEmbed) {
    return (
      <div className="w-full text-left space-y-6 font-sans">
        {/* Toast Banner */}
        {toastMessage && (
          <div className="fixed top-4 right-4 bg-purple-950 border border-purple-500 text-white font-mono text-xs px-5 py-3.5 rounded-xl z-[11000] shadow-[0_0_20px_rgba(168,85,247,0.4)] flex items-center gap-2">
            <Activity size={12} className="text-cyan-400 animate-pulse" />
            <span>{toastMessage}</span>
          </div>
        )}

        {renderDirectorControlDashboard()}

        {/* Remote Workforce OS Upgrade Modals */}
        {renderWorkforceDirectorModals()}
        {renderWorkforceWorkerModals()}
      </div>
    );
  }
  const renderWorkerVerificationCentrePanel = () => {
    const trialWorkers = operatorsList.filter(op => op.status === 'Pending Verification' && op.email.toLowerCase() !== 'siddique.mahmood@gmail.com');
    const uploadedDocs = verificationsList.filter(v => v.status === 'Under Review' || v.status === 'Uploaded');
    const verifiedWorkers = operatorsList.filter(op => op.verificationStatus === 'Verified');
    const rejectedWorkers = verificationsList.filter(v => v.status === 'Rejected' || v.status === 'ID Required');
    
    const handleTestUpload = async (email: string) => {
      try {
        const res = await fetch('/api/admin/workforce/verification/test-upload', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        });
        const data = await res.json();
        if (data.success) {
          triggerToast("Dummy test document uploaded successfully.");
          syncData();
        } else {
          triggerToast(data.error || "Failed to upload test document.");
        }
      } catch (err) {
        triggerToast("Network error uploading test document.");
      }
    };

    const handleSimulateSignAgreement = async (email: string) => {
      try {
        const targetOp = operatorsList.find(op => op.email.toLowerCase() === email.toLowerCase());
        if (!targetOp) return;
        const res = await fetch(`/api/operator/admin/operators/${targetOp.operator_id}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ agreement_accepted_at: new Date().toISOString() })
        });
        const data = await res.json();
        if (data.success) {
          triggerToast("Agreement signed for worker " + targetOp.name);
          syncData();
        } else {
          triggerToast(data.error || "Failed to sign agreement.");
        }
      } catch (err) {
        triggerToast("Network error signing agreement.");
      }
    };

    const handleActivateWorker = async (email: string) => {
      try {
        const targetOp = operatorsList.find(op => op.email.toLowerCase() === email.toLowerCase());
        if (!targetOp) return;
        const res = await fetch(`/api/operator/admin/operators/${targetOp.operator_id}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ status: 'Active', loginAccess: 'enabled' })
        });
        const data = await res.json();
        if (data.success) {
          triggerToast("Operator activated and login enabled!");
          syncData();
        } else {
          triggerToast(data.error || "Failed to activate worker.");
        }
      } catch (err) {
        triggerToast("Network error activating worker.");
      }
    };

    const handleSaveNotes = async (email: string, notes: string) => {
      try {
        const ver = verificationsList.find(v => v.email.toLowerCase() === email.toLowerCase());
        if (ver) {
          const res = await fetch('/api/admin/workforce/verification/review', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ verificationId: ver.id, status: ver.status, directorNotes: notes })
          });
          const data = await res.json();
          if (data.success) {
            triggerToast("Notes saved successfully.");
            syncData();
          } else {
            triggerToast(data.error || "Failed to save notes.");
          }
        } else {
          const targetOp = operatorsList.find(op => op.email.toLowerCase() === email.toLowerCase());
          if (targetOp) {
            const res = await fetch(`/api/operator/admin/operators/${targetOp.operator_id}`, {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ notes })
            });
            const data = await res.json();
            if (data.success) {
              triggerToast("Notes saved successfully.");
              syncData();
            } else {
              triggerToast(data.error || "Failed to save notes.");
            }
          }
        }
      } catch (err) {
        triggerToast("Network error saving notes.");
      }
    };

    return (
      <div className="space-y-6 text-left">
        
        {/* Section 1: Trial Workers Pending Verification */}
        <div className="bg-zinc-950 border border-zinc-900 p-6 rounded-3xl space-y-4">
          <h3 className="text-white font-bold uppercase text-[11px] tracking-wider border-b border-zinc-900 pb-2 flex justify-between items-center">
            <span>01. Trial Workers Pending Verification</span>
            <span className="px-2 py-0.5 bg-amber-500/10 text-amber-400 border border-amber-500/30 rounded text-[9px] font-bold">
              {trialWorkers.length} Pending
            </span>
          </h3>

          <div className="space-y-4">
            {trialWorkers.length === 0 ? (
              <div className="p-4 text-center text-slate-500 text-[10.5px]">No trial workers pending verification.</div>
            ) : (
              trialWorkers.map(op => {
                const ver = verificationsList.find(v => v.email.toLowerCase() === op.email.toLowerCase());
                const agreementSigned = !!op.agreement_accepted_at;
                const hasUploadedDoc = !!(ver && ver.idFile);
                const verificationStatusStr = ver ? ver.status : op.verificationStatus;
                
                return (
                  <div key={op.operator_id} className="p-4 bg-black/40 border border-zinc-900 rounded-2xl space-y-3">
                    <div className="flex justify-between items-start flex-wrap gap-2">
                      <div>
                        <div className="text-white font-bold text-sm flex items-center gap-2">
                          <span>{op.name}</span>
                          <span className="px-1.5 py-0.5 bg-purple-900/35 border border-purple-500/30 text-purple-300 rounded text-[8px] uppercase tracking-wider">{op.role}</span>
                          <span className="px-1.5 py-0.5 bg-yellow-500/10 border border-yellow-500/30 text-yellow-500 rounded text-[8px] font-bold uppercase tracking-wider">
                            {verificationStatusStr}
                          </span>
                        </div>
                        <div className="text-slate-500 text-[10.5px] pt-1">ID: {op.operator_id} | Email: {op.email} | Country: {op.country}</div>
                      </div>
                    </div>

                    {/* Status grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-[10px] bg-zinc-950/80 p-3 rounded-xl border border-zinc-900">
                      <div>
                        <span className="text-slate-500">ID Verification:</span>{' '}
                        <span className={hasUploadedDoc ? 'text-emerald-400 font-bold' : 'text-rose-400 font-bold'}>
                          {hasUploadedDoc ? 'Document Uploaded' : 'ID Required'}
                        </span>
                      </div>
                      <div>
                        <span className="text-slate-500">Agreement:</span>{' '}
                        <span className={agreementSigned ? 'text-emerald-400 font-bold' : 'text-rose-400 font-bold'}>
                          {agreementSigned ? 'Agreement Signed' : 'Agreement Required'}
                        </span>
                      </div>
                      <div>
                        <span className="text-slate-500">Login Access:</span>{' '}
                        <span className="text-rose-400 font-bold">Login Disabled</span>
                      </div>
                    </div>

                    {/* Director Notes */}
                    <div className="space-y-1">
                      <label className="text-[8px] text-slate-500 uppercase font-bold">Director Notes:</label>
                      <div className="flex gap-2">
                        <textarea
                          defaultValue={ver ? ver.directorNotes : (op.notes || '')}
                          id={`notes-pending-${op.email}`}
                          className="bg-black border border-zinc-850 text-white rounded-xl p-2 text-[10px] w-full h-11 resize-none outline-none focus:border-purple-500"
                          placeholder="Add director instructions/audit logs here..."
                        />
                        <button
                          type="button"
                          onClick={() => {
                            const val = (document.getElementById(`notes-pending-${op.email}`) as HTMLTextAreaElement)?.value;
                            handleSaveNotes(op.email, val);
                          }}
                          className="px-3 bg-zinc-900 hover:bg-zinc-800 text-slate-300 rounded-xl border border-zinc-800 font-bold text-[9px] uppercase cursor-pointer"
                        >
                          Save
                        </button>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-wrap gap-2 pt-1.5 border-t border-zinc-900/60">
                      <button
                        type="button"
                        onClick={() => handleTestUpload(op.email)}
                        className="px-3 py-1.5 bg-cyan-950/40 hover:bg-cyan-900/40 text-cyan-300 border border-cyan-500/20 rounded-xl font-bold uppercase text-[9px] cursor-pointer"
                      >
                        Upload Test Document
                      </button>
                      <button
                        type="button"
                        onClick={() => handleSimulateSignAgreement(op.email)}
                        className="px-3 py-1.5 bg-purple-950/40 hover:bg-purple-900/40 text-purple-300 border border-purple-500/20 rounded-xl font-bold uppercase text-[9px] cursor-pointer"
                      >
                        Simulate Sign Agreement
                      </button>
                      <button
                        type="button"
                        onClick={() => handleReviewWorkerVerification(op.email, 'ID Required')}
                        className="px-3 py-1.5 bg-zinc-900 hover:bg-zinc-800 text-slate-355 border border-zinc-800 rounded-xl font-bold uppercase text-[9px] cursor-pointer"
                      >
                        Request Upload
                      </button>
                      <button
                        type="button"
                        onClick={() => handleReviewWorkerVerification(op.email, 'Rejected')}
                        className="px-3 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 border border-rose-500/25 rounded-xl font-bold uppercase text-[9px] cursor-pointer"
                      >
                        Reject
                      </button>
                      
                      <button
                        type="button"
                        disabled={!hasUploadedDoc || !agreementSigned || verificationStatusStr === 'Verified'}
                        onClick={() => handleReviewWorkerVerification(op.email, 'Verified')}
                        className="px-3 py-1.5 bg-purple-650 hover:bg-purple-600 disabled:opacity-30 disabled:pointer-events-none text-white rounded-xl font-bold uppercase text-[9px] cursor-pointer ml-auto"
                      >
                        Approve Verification
                      </button>

                      <button
                        type="button"
                        disabled={verificationStatusStr !== 'Verified'}
                        onClick={() => handleActivateWorker(op.email)}
                        className="px-3 py-1.5 bg-emerald-500/20 hover:bg-emerald-500/30 disabled:opacity-30 disabled:pointer-events-none text-emerald-400 border border-emerald-500/25 rounded-xl font-bold uppercase text-[9px] cursor-pointer"
                      >
                        Activate after Verification
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Section 2: Uploaded Documents Under Review */}
        <div className="bg-zinc-950 border border-zinc-900 p-6 rounded-3xl space-y-4">
          <h3 className="text-white font-bold uppercase text-[11px] tracking-wider border-b border-zinc-900 pb-2 flex justify-between items-center">
            <span>02. Uploaded Documents Under Review</span>
            <span className="px-2 py-0.5 bg-cyan-500/10 text-cyan-400 border border-cyan-500/30 rounded text-[9px] font-bold">
              {uploadedDocs.length} Under Review
            </span>
          </h3>

          <div className="space-y-4">
            {uploadedDocs.length === 0 ? (
              <div className="p-4 text-center text-slate-500 text-[10.5px]">No uploaded documents pending review.</div>
            ) : (
              uploadedDocs.map(ver => (
                <div key={ver.id} className="p-4 bg-black/40 border border-zinc-900 rounded-2xl space-y-3">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="text-white font-bold text-sm">{ver.fullName} ({ver.email})</div>
                      <div className="text-slate-500 text-[10px] pt-0.5">Role: {ver.workerRole} | Country: {ver.country}</div>
                      <div className="text-[10px] text-cyan-400 font-mono pt-1">Doc File: {ver.idFile} | Selfie: {ver.selfieFile}</div>
                    </div>
                    <span className="px-2 py-0.5 bg-cyan-500/10 text-cyan-400 border border-cyan-500/30 rounded text-[8px] font-mono uppercase">
                      {ver.status}
                    </span>
                  </div>

                  {/* Director Notes */}
                  <div className="space-y-1">
                    <label className="text-[8px] text-slate-500 uppercase font-bold">Director Notes:</label>
                    <div className="flex gap-2">
                      <textarea
                        defaultValue={ver.directorNotes}
                        id={`notes-review-${ver.email}`}
                        className="bg-black border border-zinc-850 text-white rounded-xl p-2 text-[10px] w-full h-11 resize-none outline-none focus:border-purple-500"
                        placeholder="Add director instructions/audit logs here..."
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const val = (document.getElementById(`notes-review-${ver.email}`) as HTMLTextAreaElement)?.value;
                          handleSaveNotes(ver.email, val);
                        }}
                        className="px-3 bg-zinc-900 hover:bg-zinc-800 text-slate-300 rounded-xl border border-zinc-800 font-bold text-[9px] uppercase cursor-pointer"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <div className="flex gap-2 pt-1 border-t border-zinc-900/60">
                    <button onClick={() => handleReviewWorkerVerification(ver.email, 'Verified')} className="px-2.5 py-1.5 bg-purple-650 hover:bg-purple-600 text-white rounded-xl font-bold uppercase text-[9px] cursor-pointer">
                      Approve
                    </button>
                    <button onClick={() => handleReviewWorkerVerification(ver.email, 'Rejected')} className="px-2.5 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-450 border border-rose-500/25 rounded-xl font-bold uppercase text-[9px] cursor-pointer">
                      Reject
                    </button>
                    <button onClick={() => handleReviewWorkerVerification(ver.email, 'ID Required')} className="px-2.5 py-1.5 bg-zinc-900 hover:bg-zinc-800 text-slate-350 border border-zinc-800 rounded-xl font-bold uppercase text-[9px] cursor-pointer">
                      Request Re-upload
                    </button>
                    <button onClick={async () => {
                      if (window.confirm("Are you sure you want to delete this worker's uploaded verification files?")) {
                        try {
                          const res = await fetch('/api/admin/workforce/verification/delete', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ verificationId: ver.id })
                          });
                          const data = await res.json();
                          if (data.success) {
                            triggerToast("Verification files deleted.");
                            syncData();
                          } else {
                            triggerToast(data.error || "Failed to delete files.");
                          }
                        } catch (err) {
                          triggerToast("Network error deleting files.");
                        }
                      }
                    }} className="px-2.5 py-1.5 bg-rose-550/20 hover:bg-rose-500/30 text-rose-400 border border-rose-550/30 rounded-xl font-bold uppercase text-[9px] cursor-pointer ml-auto">
                      Delete Files
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Section 3: Verified Workers */}
        <div className="bg-zinc-950 border border-zinc-900 p-6 rounded-3xl space-y-4">
          <h3 className="text-white font-bold uppercase text-[11px] tracking-wider border-b border-zinc-900 pb-2">
            03. Verified Workers
          </h3>
          <div className="space-y-3">
            {verifiedWorkers.length === 0 ? (
              <div className="p-4 text-center text-slate-500 text-[10.5px]">No verified workers in directory.</div>
            ) : (
              verifiedWorkers.map(op => (
                <div key={op.operator_id} className="p-4 bg-black/40 border border-zinc-900 rounded-2xl flex justify-between items-center">
                  <div>
                    <div className="text-white font-bold text-sm">{op.name} ({op.email})</div>
                    <div className="text-slate-500 text-[10px]">ID: {op.operator_id} | Location: {op.country} | Role: {op.role}</div>
                  </div>
                  <span className="px-2 py-0.5 bg-emerald-500/10 text-emerald-455 border border-emerald-500/30 rounded text-[9px] font-bold uppercase">
                    Verified &amp; Active
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Section 4: Rejected / Re-upload Required */}
        <div className="bg-zinc-950 border border-zinc-900 p-6 rounded-3xl space-y-4">
          <h3 className="text-white font-bold uppercase text-[11px] tracking-wider border-b border-zinc-900 pb-2">
            04. Rejected / Re-upload Required
          </h3>
          <div className="space-y-3">
            {rejectedWorkers.length === 0 ? (
              <div className="p-4 text-center text-slate-500 text-[10.5px]">No workers with rejected status.</div>
            ) : (
              rejectedWorkers.map(ver => (
                <div key={ver.id} className="p-4 bg-black/40 border border-zinc-900 rounded-2xl flex justify-between items-center">
                  <div>
                    <div className="text-white font-bold text-sm">{ver.fullName} ({ver.email})</div>
                    <div className="text-slate-500 text-[10px]">Status: {ver.status} | Last Notes: {ver.directorNotes}</div>
                  </div>
                  <span className="px-2 py-0.5 bg-rose-500/10 text-rose-455 border border-rose-500/30 rounded text-[9px] font-bold uppercase">
                    {ver.status}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Section 5: Test Upload Area */}
        <div className="bg-zinc-950 border border-zinc-900 p-6 rounded-3xl space-y-4">
          <h3 className="text-white font-bold uppercase text-[11px] tracking-wider border-b border-zinc-900 pb-2">
            05. Test Upload Area
          </h3>
          <div className="p-4 bg-black/40 border border-zinc-900 rounded-2xl flex flex-col sm:flex-row gap-4 items-end">
            <div className="flex-1 space-y-1">
              <label className="text-[9px] uppercase font-bold text-slate-500">Select Trial Worker for Test Upload</label>
              <select id="test-upload-select-email" className="w-full bg-zinc-900 border border-zinc-800 p-2.5 rounded-xl text-white outline-none text-[11px]">
                {trialWorkers.map(op => (
                  <option key={op.operator_id} value={op.email}>{op.name} ({op.email})</option>
                ))}
                {trialWorkers.length === 0 && <option value="">No trial workers available</option>}
              </select>
            </div>
            <button
              type="button"
              disabled={trialWorkers.length === 0}
              onClick={() => {
                const emailVal = (document.getElementById('test-upload-select-email') as HTMLSelectElement)?.value;
                if (emailVal) handleTestUpload(emailVal);
              }}
              className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 disabled:opacity-40 disabled:pointer-events-none text-white font-black uppercase rounded-xl cursor-pointer text-[10px]"
            >
              Generate &amp; Upload Test Document
            </button>
          </div>
        </div>

      </div>
    );
  };

  function renderDirectorControlDashboard() {
    return (
      <div className="space-y-6 text-left font-mono text-xs">
        <div className="border-b border-white/5 pb-3">
          <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
            <ShieldCheck size={16} className="text-purple-400" />
            <span>Remote Workforce Control Dashboard</span>
          </h2>
          <p className="text-[10px] text-slate-500 uppercase pt-1">
            Monitor remote operators, sessions, security audit logs, and approve commission claims.
          </p>
        </div>

        {/* 11 Numbered Subtabs */}
        <div className="space-y-3">
          <div className="flex flex-wrap gap-1.5 text-[10.5px] font-mono font-bold uppercase bg-zinc-950/60 p-1.5 rounded-2xl border border-zinc-900">
            {[
              { id: '01. Overview', label: '01. Overview' },
              { id: '02. Production Hub', label: '02. Production Hub' },
              { id: '03. Worker Tasks', label: '03. Worker Tasks' },
              { id: '04. Worker Verification', label: '04. Worker Verification' },
              { id: '05. Worker Directory', label: '05. Worker Directory' },
              { id: '06. Specialist Directory', label: '06. Specialist Directory' },
              { id: '07. Commission Tracking', label: '07. Commission Tracking' },
              { id: '08. Campaign Traffic Tracker', label: '08. Campaign Traffic Tracker' },
              { id: '09. Audit Logs', label: '09. Audit Logs' },
              { id: '10. Security Test', label: '10. Security Test' },
              { id: '11. Settings', label: '11. Settings' }
            ].map(t => (
              <button key={t.id} type="button" onClick={() => setControlSubtab(t.id)} className={`py-1 px-3 rounded-xl cursor-pointer transition-all ${controlSubtab === t.id ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500 hover:text-slate-305'}`}>
                {t.label}
              </button>
            ))}
          </div>

          {/* One-line explanation */}
          <div className="p-3 bg-zinc-900/40 border border-zinc-900 rounded-xl text-[10px] text-slate-400 font-mono">
            {controlSubtab === '01. Overview' && '01. Overview - Monitor active sessions, tasks and system load.'}
            {controlSubtab === '02. Production Hub' && '02. Production Hub - Manage client tasks and campaigns.'}
            {controlSubtab === '03. Worker Tasks' && '03. Worker Tasks - Track real-time worker submissions.'}
            {controlSubtab === '04. Worker Verification' && '04. Worker Verification - Review compliance and documents.'}
            {controlSubtab === '05. Worker Directory' && '05. Worker Directory - List and configure active worker accounts.'}
            {controlSubtab === '06. Specialist Directory' && '06. Specialist Directory - List campaign and design specialists.'}
            {controlSubtab === '07. Commission Tracking' && '07. Commission Tracking - Audit and approve worker payouts.'}
            {controlSubtab === '08. Campaign Traffic Tracker' && '08. Campaign Traffic Tracker - Audit visitor tracking links.'}
            {controlSubtab === '09. Audit Logs' && '09. Audit Logs - Search workspace audit and security logs.'}
            {controlSubtab === '10. Security Test' && '10. Security Test - Run verification and isolation checks.'}
            {controlSubtab === '11. Settings' && '11. Settings - Send operator invites and manage settings.'}
          </div>
        </div>

        {/* TAB CONTENTS */}
        <div className="space-y-6">

          {/* TAB 01: OVERVIEW */}
          {controlSubtab === '01. Overview' && (
            <div className="space-y-6">
              {/* System Load Mock Indicators */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {[
                  { label: 'CPU LOAD', val: '42%', color: 'text-emerald-400' },
                  { label: 'MEMORY LOAD', val: '14.2GB', color: 'text-emerald-400' },
                  { label: 'ACTIVE WORKERS', val: String(operatorsList.filter(o => o.status === 'Active').length), color: 'text-purple-400' },
                  { label: 'PENDING VERIFICATION', val: String(operatorsList.filter(o => o.status === 'Pending Verification').length), color: 'text-amber-400' }
                ].map((s, idx) => (
                  <div key={idx} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl flex flex-col justify-center text-left">
                    <span className="text-[9px] text-slate-500 font-bold uppercase tracking-wider">{s.label}</span>
                    <span className={`text-xl font-bold font-mono pt-1 ${s.color}`}>{s.val}</span>
                  </div>
                ))}
              </div>

              {/* Active Sessions List */}
              <div className="space-y-4">
                <div className="text-white font-bold uppercase text-[10px] tracking-wider">Active Overwatch Operator Sessions</div>
                <div className="overflow-x-auto border border-zinc-900 rounded-2xl">
                  <table className="w-full text-left border-collapse text-[10.5px]">
                    <thead>
                      <tr className="border-b border-zinc-900 bg-zinc-950/80 text-slate-400">
                        <th className="p-3">Email</th>
                        <th className="p-3">Role</th>
                        <th className="p-3">IP Address</th>
                        <th className="p-3">Login Time</th>
                        <th className="p-3">Last Seen</th>
                        <th className="p-3">Duration</th>
                        <th className="p-3">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sessionsList.length === 0 ? (
                        <tr><td colSpan={7} className="p-6 text-center text-slate-500">No sessions recorded yet.</td></tr>
                      ) : (
                        sessionsList.map((s, idx) => (
                          <tr key={idx} className="border-b border-zinc-900 bg-black/20 hover:bg-zinc-900/10">
                            <td className="p-3 text-white font-bold">{s.email}</td>
                            <td className="p-3">{s.role}</td>
                            <td className="p-3 font-mono">{s.ip}</td>
                            <td className="p-3">{new Date(s.login_time).toLocaleString()}</td>
                            <td className="p-3">{new Date(s.last_seen).toLocaleString()}</td>
                            <td className="p-3 font-mono">{s.session_duration}s</td>
                            <td className="p-3">
                              <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${
                                s.status === 'Active' ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20' : 'bg-zinc-800 text-zinc-400'
                              }`}>
                                {s.status}
                              </span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* TAB 02: PRODUCTION HUB */}
          {controlSubtab === '02. Production Hub' && renderProductionHubSubtab()}

          {/* TAB 03: WORKER TASKS */}
          {controlSubtab === '03. Worker Tasks' && (
            <div className="space-y-6">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">WORKSPACE TEAM MEMBER TASKS</div>
              
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 space-y-4">
                  <div className="space-y-3">
                    {buildTasks.length === 0 ? (
                      <div className="p-6 text-center text-slate-500 border border-zinc-900 rounded-2xl">No tasks dispatched yet today.</div>
                    ) : (
                      buildTasks.map((t, idx) => (
                        <div key={idx} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl flex justify-between items-center flex-wrap gap-4">
                          <div>
                            <div className="text-white font-bold text-sm flex items-center gap-2">
                              <span>{t.title || 'Workspace Build Task'}</span>
                              <span className="px-1.5 py-0.5 bg-purple-900/35 border border-purple-500/30 text-purple-300 rounded text-[8px] uppercase tracking-wider">
                                {t.status || 'Pending'}
                              </span>
                            </div>
                            <div className="text-slate-500 text-[10px] pt-1">Operator: {t.operator_id} | Brief: {t.brief || 'No details provided.'}</div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>

                {/* Task Assignment Form */}
                <div className="bg-zinc-950 border border-zinc-900 p-5 rounded-2xl space-y-4 h-fit">
                  <div className="text-white font-bold uppercase text-[10px] tracking-wider border-b border-zinc-900 pb-2">Assign Workspace Task</div>
                  <form onSubmit={handleAssignTask} className="space-y-3 text-[10.5px]">
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Operator ID</label>
                      <input type="text" value={directorAssignForm.operatorId} onChange={(e) => setDirectorAssignForm({ ...directorAssignForm, operatorId: e.target.value })} placeholder="op-xxxx" className="w-full bg-black border border-zinc-850 p-2.5 rounded-xl text-white outline-none" required />
                    </div>
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Task Title</label>
                      <input type="text" value={directorAssignForm.taskTitle} onChange={(e) => setDirectorAssignForm({ ...directorAssignForm, taskTitle: e.target.value })} placeholder="e.g. Set up launchcare button" className="w-full bg-black border border-zinc-850 p-2.5 rounded-xl text-white outline-none" required />
                    </div>
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Task Brief / Details</label>
                      <textarea value={directorAssignForm.brief} onChange={(e) => setDirectorAssignForm({ ...directorAssignForm, brief: e.target.value })} placeholder="Provide build details..." className="w-full bg-black border border-zinc-855 p-2.5 rounded-xl text-white outline-none h-20 resize-none" />
                    </div>
                    <button type="submit" className="w-full py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Assign task
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* TAB 04: WORKER VERIFICATION */}
          {controlSubtab === '04. Worker Verification' && renderWorkerVerificationCentrePanel()}

          {/* TAB 05: WORKER DIRECTORY */}
          {controlSubtab === '05. Worker Directory' && (
            <div className="space-y-6">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">ACTIVE WORKFORCE DIRECTORY</div>
              <div className="space-y-3">
                {operatorsList.filter(op => op.status === 'Active').map((op) => (
                  <div key={op.operator_id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl flex justify-between items-center flex-wrap gap-4">
                    <div>
                      <div className="text-white font-bold text-sm flex items-center gap-2">
                        <span>{op.name}</span>
                        <span className="px-1.5 py-0.5 bg-purple-900/35 border border-purple-500/30 text-purple-300 rounded text-[8px] uppercase tracking-wider">{op.role}</span>
                        <span className="px-1.5 py-0.5 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 rounded text-[8px] font-bold uppercase tracking-wider">
                          ACTIVE
                        </span>
                      </div>
                      <div className="text-slate-500 text-[10px] pt-1">ID: {op.operator_id} | Email: {op.email} | {op.country}</div>
                      <div className="text-[10px] text-purple-400 pt-1">Quality Score: {op.qualityScore || 95}% | Notes: {op.notes || 'No notes.'}</div>
                    </div>
                    
                    <div className="flex gap-2">
                      {op.email.toLowerCase() === "siddique.mahmood@gmail.com" ? (
                        <span className="px-3 py-1.5 bg-purple-500/20 text-purple-300 border border-purple-500/40 rounded-xl font-bold uppercase text-[9px]">
                          PROTECTED DIRECTOR ACCOUNT
                        </span>
                      ) : (
                        <button onClick={() => handleModifyOperatorStatus(op.operator_id, 'Suspended')} className="px-3 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-455 border border-rose-500/25 rounded-xl cursor-pointer font-bold uppercase text-[9px]">
                          Suspend
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* TAB 06: SPECIALIST DIRECTORY */}
          {controlSubtab === '06. Specialist Directory' && (
            <div className="space-y-6">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">SPECIALIST &amp; DESIGN PARTNERS</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { name: 'Suhail', role: 'Canva / Video Design Specialist', country: 'Pakistan', email: 'suhail@nexoraxdigital.co.uk' },
                  { name: 'Sarah', role: 'Digital Copywriting Lead', country: 'United Kingdom', email: 'sarah@nexoraxdigital.co.uk' },
                  { name: 'Imran', role: 'Local SEO Specialist', country: 'Pakistan', email: 'imran@nexoraxdigital.co.uk' }
                ].map((spec, i) => (
                  <div key={i} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl flex flex-col gap-2">
                    <div className="text-white font-bold text-sm flex items-center justify-between">
                      <span>{spec.name}</span>
                      <span className="px-1.5 py-0.5 bg-purple-900/35 border border-purple-500/30 text-purple-300 rounded text-[8px] uppercase tracking-wider">{spec.role}</span>
                    </div>
                    <div className="text-slate-500 text-[10px]">Email: {spec.email} | Location: {spec.country}</div>
                    <div className="text-[10px] text-purple-400 pt-1">• Specialist verified for campaign asset design assignment.</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* TAB 07: COMMISSION TRACKING */}
          {controlSubtab === '07. Commission Tracking' && (
            <div className="space-y-4">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">PENDING COMMISSION APPROVAL QUEUE</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {commissions.length === 0 ? (
                  <div className="col-span-2 text-center text-slate-500 py-6 border border-zinc-900 rounded-2xl">No commissions logged.</div>
                ) : (
                  commissions.map((c) => (
                    <div key={c.id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-3">
                      <div className="flex justify-between items-start">
                        <div>
                          <h4 className="text-white font-bold text-sm">{c.commissionType}</h4>
                          <p className="text-slate-500 text-[9px] pt-0.5">Operator: {c.operatorEmail} | ID: {c.id}</p>
                        </div>
                        <span className={`px-2 py-0.5 rounded text-[9px] uppercase font-bold ${
                          c.status === 'Paid' ? 'bg-emerald-500/20 text-emerald-400' :
                          c.status === 'Approved' ? 'bg-purple-500/20 text-purple-400' : 'bg-amber-500/20 text-amber-400'
                        }`}>
                          {c.status}
                        </span>
                      </div>
                      
                      <div className="flex justify-between items-center border-t border-zinc-900 pt-2.5">
                        <span className="text-slate-400 text-xs font-black">Estimate: GBP {parseFloat(c.estimatedCommission).toFixed(2)}</span>
                        
                        <div className="flex gap-2">
                          {c.status !== 'Approved' && c.status !== 'Paid' && (
                            <button onClick={() => handleApproveCommission(c.id)} className="px-2.5 py-1 bg-purple-650 hover:bg-purple-600 text-white font-bold rounded text-[9px] uppercase cursor-pointer">
                              Approve
                            </button>
                          )}
                          {c.status === 'Approved' && (
                            <button onClick={() => handleMarkPaidCommission(c.id)} className="px-2.5 py-1 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded text-[9px] uppercase cursor-pointer">
                              Mark Paid
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* TAB 08: CAMPAIGN TRAFFIC TRACKER */}
          {controlSubtab === '08. Campaign Traffic Tracker' && renderTrafficTrackerSubtab()}

          {/* TAB 09: AUDIT LOGS */}
          {controlSubtab === '09. Audit Logs' && (
            <div className="space-y-4">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">WORKSPACE SECURITY AUDIT LOG TRAIL</div>
              <div className="space-y-2 max-h-96 overflow-y-auto pr-2">
                {auditLogsList.length === 0 ? (
                  <div className="p-6 text-center text-slate-500 border border-zinc-900 rounded-xl">No logs recorded yet.</div>
                ) : (
                  [...auditLogsList].reverse().map((log) => {
                    const isSuspicious = ["ACCESS_DENIED", "DENIED_CROSS_WORKSPACE_ACCESS", "DENIED_DIRECTOR_ACTION", "SUSPENDED_ACCESS_DENIED", "UNAUTHORIZED_EDIT"].includes(log.action);
                    return (
                      <div key={log.id} className={`p-3 rounded-xl border flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-left ${
                        isSuspicious ? 'bg-rose-500/10 border-rose-500/30' : 'bg-zinc-950 border-zinc-900'
                      }`}>
                        <div className="space-y-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className={`px-2 py-0.5 rounded text-[8px] font-bold uppercase ${
                              isSuspicious ? 'bg-rose-600 text-white animate-pulse' : 'bg-purple-900/30 text-purple-300 border border-purple-500/20'
                            }`}>
                              {log.action}
                            </span>
                            <span className="text-white font-black">{log.operatorEmail}</span>
                            <span className="text-slate-500 text-[9px]">{new Date(log.timestamp).toLocaleString()}</span>
                          </div>
                          <p className="text-slate-400 text-[10.5px] leading-relaxed">{log.details}</p>
                        </div>
                        {isSuspicious && (
                          <span className="px-2 py-0.5 bg-rose-950 border border-rose-500/40 text-rose-450 rounded text-[8px] font-bold uppercase tracking-wider flex items-center gap-0.5">
                            <AlertTriangle size={8} /> SUSPICIOUS EVENT
                          </span>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}

          {/* TAB 10: SECURITY TEST */}
          {controlSubtab === '10. Security Test' && (
            <div className="space-y-6">
              <div className="flex justify-between items-center border-b border-zinc-900 pb-3">
                <div className="text-white font-bold uppercase text-[10px] tracking-wider">ONE-CLICK WORKSPACE SECURITY AUDIT</div>
                <button 
                  onClick={handleRunIsolationTest} 
                  disabled={isTestingSecurity}
                  className="px-4 py-2 bg-gradient-to-r from-red-650 to-purple-650 hover:from-red-600 hover:to-purple-600 text-white font-mono text-[10px] font-black uppercase tracking-wider rounded-xl cursor-pointer shadow-[0_0_15px_rgba(239,68,68,0.2)] disabled:opacity-55"
                >
                  {isTestingSecurity ? 'Running Verification...' : '🛡️ Run Isolation Security Test'}
                </button>
              </div>

              {/* Isolation Security Test Results */}
              {testResults.length > 0 && (
                <div className="p-5 bg-zinc-950 border border-red-500/30 rounded-2xl space-y-4">
                  <div className="flex justify-between items-center border-b border-zinc-900 pb-2">
                    <div className="text-white font-bold uppercase text-[11px] tracking-wider flex items-center gap-1.5">
                      <ShieldAlert size={14} className="text-red-400" />
                      <span>Isolation Security Test Results</span>
                    </div>
                    <button onClick={() => setTestResults([])} className="text-[9px] text-slate-500 hover:text-slate-350">Clear Results</button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-[10px]">
                    {testResults.map((res, idx) => (
                      <div key={idx} className="p-3 bg-black/40 border border-zinc-900 rounded-xl space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-white font-bold">{res.name}</span>
                          <span className={`px-2 py-0.5 rounded text-[8px] font-bold ${
                            res.status === 'PASS' ? 'bg-emerald-500/10 text-emerald-450 border border-emerald-500/20' : 'bg-rose-500/10 text-rose-455 border border-rose-500/20'
                          }`}>
                            {res.status}
                          </span>
                        </div>
                        <p className="text-slate-400 text-[9.5px] leading-relaxed">{res.notes}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 11: SETTINGS */}
          {controlSubtab === '11. Settings' && (
            <div className="space-y-6">
              <div className="text-white font-bold uppercase text-[10px] tracking-wider">SYSTEM SETTINGS &amp; INVITE GENERATOR</div>
              
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Invites list */}
                <div className="lg:col-span-2 space-y-4">
                  <div className="text-white font-bold uppercase text-[10px] tracking-wider mb-2">Active Operator Invitations</div>
                  <div className="space-y-3">
                    {invitesList.length === 0 ? (
                      <div className="p-6 text-center text-slate-500 border border-zinc-900 rounded-2xl">No invitations created yet.</div>
                    ) : (
                      invitesList.map((inv) => (
                        <div key={inv.invite_id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl flex justify-between items-center flex-wrap gap-4">
                          <div className="space-y-1">
                            <div className="text-white font-bold text-sm flex items-center gap-2">
                              <span>{inv.worker_name}</span>
                              <span className={`px-1.5 py-0.5 rounded text-[8px] font-bold uppercase tracking-wider ${
                                inv.status === 'Accepted' ? 'bg-emerald-500/10 border border-emerald-500/30 text-emerald-400' :
                                inv.status === 'Pending' ? 'bg-amber-500/10 border border-amber-500/30 text-amber-400' : 'bg-zinc-800 border border-zinc-700 text-zinc-400'
                              }`}>
                                {inv.status}
                              </span>
                            </div>
                            <div className="text-slate-400 text-[10px]">Email: {inv.worker_email}</div>
                            <div className="text-[10px] text-purple-400">Commission Type: {inv.commission_type}</div>
                            <div className="text-[9px] text-slate-500 font-mono">
                              Code: <span className="text-cyan-400 font-black">{inv.invite_code}</span> | 
                              Created: {new Date(inv.created_at).toLocaleDateString()} | 
                              Expires: {new Date(inv.expires_at).toLocaleDateString()}
                            </div>
                            {inv.notes && <div className="text-[9px] text-slate-550">Notes: {inv.notes}</div>}
                          </div>

                          <div className="flex gap-2">
                            {inv.status === 'Pending' && (
                              <>
                                <button 
                                  onClick={() => {
                                    navigator.clipboard.writeText(`${window.location.origin}/operator-onboarding?code=${inv.invite_code}`);
                                    triggerToast("Onboarding link copied to clipboard!");
                                  }} 
                                  className="px-2.5 py-1.5 bg-purple-500/10 hover:bg-purple-500/20 text-purple-300 border border-purple-500/25 rounded-xl cursor-pointer font-bold uppercase text-[9px]"
                                >
                                  Copy Link
                                </button>
                                <button 
                                  onClick={() => handleCancelInvite(inv.invite_id)} 
                                  className="px-2.5 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-455 border border-rose-500/25 rounded-xl cursor-pointer font-bold uppercase text-[9px]"
                                >
                                  Cancel
                                </button>
                              </>
                            )}
                            {inv.status === 'Accepted' && (
                              inv.worker_email.toLowerCase() === "siddique.mahmood@gmail.com" ? (
                                <span className="px-2.5 py-1.5 bg-purple-500/20 text-purple-300 border border-purple-500/40 rounded-xl font-bold uppercase text-[9px]">
                                  PROTECTED DIRECTOR ACCOUNT
                                </span>
                              ) : (
                                <>
                                  <button 
                                    onClick={() => handleModifyWorkerStatus(inv.worker_email, 'Suspended')}
                                    className="px-2.5 py-1.5 bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/25 rounded-xl cursor-pointer font-bold uppercase text-[9px]"
                                  >
                                    Suspend
                                  </button>
                                  <button 
                                    onClick={() => handleModifyWorkerStatus(inv.worker_email, 'Disabled')}
                                    className="px-2.5 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-455 border border-rose-500/25 rounded-xl cursor-pointer font-bold uppercase text-[9px]"
                                  >
                                    Disable
                                  </button>
                                  <button 
                                    onClick={async () => {
                                      if (window.confirm("Are you sure you want to remove this test worker profile from staging? This will delete the worker profile from the database.")) {
                                        try {
                                          const res = await fetch(`/api/operator/admin/workers/${inv.worker_email}/remove`, { method: 'POST' });
                                          const data = await res.json();
                                          if (data.success) {
                                            triggerToast("Test worker profile removed successfully.");
                                            syncData();
                                          } else {
                                            triggerToast(data.error || "Failed to remove worker profile.");
                                          }
                                        } catch (e) {
                                          triggerToast("Failed to remove worker profile.");
                                        }
                                      }
                                    }}
                                    className="px-2.5 py-1.5 bg-rose-500/20 hover:bg-rose-500/30 text-rose-455 border border-rose-500/35 rounded-xl cursor-pointer font-bold uppercase text-[9px]"
                                  >
                                    Remove Profile
                                  </button>
                                </>
                              )
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>

                {/* Create Invite Form */}
                <div className="bg-zinc-950 border border-zinc-900 p-5 rounded-2xl space-y-4 h-fit">
                  <div className="text-white font-bold uppercase text-[10px] tracking-wider border-b border-zinc-900 pb-2">Generate Operator Invite</div>
                  <form onSubmit={handleCreateInvite} className="space-y-3 text-[10.5px]">
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Worker Name</label>
                      <input 
                        type="text" 
                        value={inviteForm.worker_name} 
                        onChange={(e) => setInviteForm({ ...inviteForm, worker_name: e.target.value })} 
                        placeholder="e.g. John Helper" 
                        className="w-full bg-black border border-zinc-850 p-2.5 rounded-xl text-white outline-none" 
                        required 
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Worker Email</label>
                      <input 
                        type="email" 
                        value={inviteForm.worker_email} 
                        onChange={(e) => setInviteForm({ ...inviteForm, worker_email: e.target.value })} 
                        placeholder="helper@nexoraxdigital.co.uk" 
                        className="w-full bg-black border border-zinc-850 p-2.5 rounded-xl text-white outline-none" 
                        required 
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Commission Type / Rate</label>
                      <input 
                        type="text" 
                        value={inviteForm.commission_type} 
                        onChange={(e) => setInviteForm({ ...inviteForm, commission_type: e.target.value })} 
                        placeholder="e.g. 5% commission per proposal" 
                        className="w-full bg-black border border-zinc-850 p-2.5 rounded-xl text-white outline-none" 
                        required 
                      />
                    </div>
                    <div className="space-y-1">
                      <label className="text-[9px] uppercase font-bold text-slate-500">Notes / Scope bounds</label>
                      <textarea 
                        value={inviteForm.notes} 
                        onChange={(e) => setInviteForm({ ...inviteForm, notes: e.target.value })} 
                        placeholder="Staging testing profile..." 
                        className="w-full bg-black border border-zinc-855 p-2.5 rounded-xl text-white outline-none h-20 resize-none" 
                      />
                    </div>
                    <button type="submit" className="w-full py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Generate invite code
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }

  function renderWorkerVerificationTab() {
    return (
      <div className="p-6 bg-zinc-950 border border-purple-500/20 rounded-3xl space-y-4 max-w-2xl text-left font-sans">
        <h2 className="text-xl font-black uppercase text-white tracking-tight flex items-center gap-2">
          <ShieldAlert className="w-6 h-6 text-purple-400" />
          <span>Worker Identity Verification</span>
        </h2>
        <p className="text-xs text-slate-400 leading-relaxed">
          Your identity verification status is currently active under the corporate overwatch protocol.
        </p>
        <div className="p-4 bg-zinc-900 border border-zinc-800 rounded-2xl flex items-center gap-3">
          <span className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-ping" />
          <span className="text-[10px] font-mono font-black uppercase text-emerald-500">Verified &amp; Cleared</span>
        </div>
      </div>
    );
  }

  function renderVerificationReviewModal() {
    if (!selectedVerForReview) return null;
    return (
      <div className="fixed inset-0 z-[12000] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
        <div className="bg-zinc-950 border border-purple-500/30 p-6 rounded-3xl max-w-md w-full space-y-4 text-left font-mono text-xs">
          <h3 className="text-sm font-black uppercase text-white tracking-wider flex items-center justify-between">
            <span>Review Worker Verification</span>
            <button onClick={() => setSelectedVerForReview(null)} className="text-slate-500 hover:text-white cursor-pointer">✕</button>
          </h3>
          <div className="space-y-2 text-slate-300">
            <div><strong>Email:</strong> {selectedVerForReview.email}</div>
            <div><strong>Full Name:</strong> {selectedVerForReview.fullName || 'N/A'}</div>
            <div><strong>Status:</strong> {selectedVerForReview.status}</div>
          </div>
          <div className="space-y-1">
            <label className="text-[10px] uppercase font-bold text-slate-400">Director Notes</label>
            <textarea 
              value={verReviewForm.directorNotes} 
              onChange={(e) => setVerReviewForm({ ...verReviewForm, directorNotes: e.target.value })}
              className="w-full bg-black border border-zinc-900 p-2.5 rounded-xl text-white outline-none resize-none" 
              rows={3} 
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button 
              onClick={() => { handleReviewWorkerVerification(selectedVerForReview.email, 'Rejected'); setSelectedVerForReview(null); }} 
              className="px-3 py-1.5 bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 border border-rose-500/20 rounded font-bold uppercase cursor-pointer"
            >
              Reject
            </button>
            <button 
              onClick={() => { handleReviewWorkerVerification(selectedVerForReview.email, 'Verified'); setSelectedVerForReview(null); }} 
              className="px-3 py-1.5 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 border border-emerald-500/20 rounded font-bold uppercase cursor-pointer"
            >
              Verify
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full text-left space-y-6 max-w-6xl mx-auto font-sans">
      
      {/* Toast Banner */}
      {toastMessage && (
        <div className="fixed top-4 right-4 bg-purple-950 border border-purple-500 text-white font-mono text-xs px-5 py-3.5 rounded-xl z-[11000] shadow-[0_0_20px_rgba(168,85,247,0.4)] flex items-center gap-2">
          <Activity size={12} className="text-cyan-400 animate-pulse" />
          <span>{toastMessage}</span>
        </div>
      )}

      {/* Header Banner */}
      <div className="relative glass-panel border border-purple-500/30 p-6 rounded-3xl bg-black/60 overflow-hidden flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="space-y-1.5 z-10 text-left">
          <div className="flex flex-wrap items-center gap-2">
            <span className="px-2 py-0.5 bg-cyan-400/10 border border-cyan-400/30 rounded text-[9px] font-mono text-cyan-400 font-bold uppercase tracking-widest">
              REMOTE OPERATOR MODE — LIMITED ACCESS
            </span>
            <span className="px-2 py-0.5 bg-purple-500/10 border border-purple-500/30 rounded text-[9px] font-mono text-purple-300 font-bold uppercase tracking-widest">
              WORKSPACE ISOLATED
            </span>
            <span className="px-2 py-0.5 bg-rose-500/10 border border-rose-500/30 rounded text-[9px] font-mono text-rose-300 font-bold uppercase tracking-widest">
              DIRECTOR APPROVAL REQUIRED
            </span>
          </div>
          <h1 className="text-2xl font-black uppercase text-white tracking-tight">
            NexoraX Remote Operator Portal
          </h1>
          <p className="text-slate-400 text-xs font-mono max-w-xl leading-normal">
            SaaS-ready tenant workspace isolation node. All operations logged under audit controls.
          </p>
        </div>

        <div className="z-10 bg-black/50 border border-zinc-900 p-3 rounded-2xl flex items-center gap-4 font-mono text-[9.5px] flex-wrap sm:flex-nowrap">
          <div className="flex gap-4 border-r border-zinc-800 pr-4">
            <div className="flex flex-col text-left">
              <span className="text-slate-500 uppercase flex items-center gap-0.5">
                <CheckCircle size={10} className="text-purple-400" /> Active Leads:
              </span>
              <span className="text-white font-black text-xs">{activeOpportunities.length}</span>
            </div>
            <div className="flex flex-col text-left">
              <span className="text-slate-500 uppercase flex items-center gap-0.5">
                <DollarSign size={10} className="text-cyan-400" /> Est Commission:
              </span>
              <span className="text-white font-black text-xs">£{commissions.reduce((acc, c) => acc + (parseFloat(c.estimatedCommission) || 0), 0).toFixed(2)}</span>
            </div>
            <div className="flex flex-col text-left">
              <span className="text-slate-500 uppercase flex items-center gap-0.5">
                <Flame size={10} className="text-amber-500 animate-pulse" /> Streak:
              </span>
              <span className="text-white font-black text-xs">6 Days</span>
            </div>
          </div>
          <button onClick={handleLogout} className="p-2 bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 border border-rose-500/20 rounded-xl cursor-pointer font-bold uppercase text-[8.5px] flex items-center gap-1">
            <LogOut size={10} /> Logout
          </button>
        </div>
      </div>

      {/* OPERATOR SESSION / IDENTITY SUBBAR */}
      <div className="bg-purple-950/10 border border-purple-500/15 p-4 rounded-2xl flex flex-wrap justify-between items-center text-left font-mono text-[10px] text-slate-400 gap-4">
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <div>
            <span className="text-slate-500 uppercase">Logged In As: </span>
            <span className="text-white font-black">{currentProfile?.name || 'Loading...'} ({currentProfile?.email || credentials.email})</span>
          </div>
          <div>
            <span className="text-slate-500 uppercase">Workspace: </span>
            <span className="text-cyan-400 font-bold">{currentWorkspace?.workspace_name || 'NexoraX Remote Operator Workspace'}</span>
          </div>
          <div>
            <span className="text-slate-500 uppercase">Role: </span>
            <span className="px-1.5 py-0.5 bg-purple-500/20 border border-purple-500/30 rounded text-purple-300 font-bold uppercase tracking-wider">{currentProfile?.role || 'OPERATOR'}</span>
          </div>
          <div>
            <span className="text-slate-500 uppercase">Session Started: </span>
            <span className="text-white">{currentSession?.login_time ? new Date(currentSession.login_time).toLocaleTimeString() : 'Connected'}</span>
          </div>
        </div>
        <div className="flex gap-4">
          <div>
            <span className="text-slate-500 uppercase">Tasks Today: </span>
            <span className="text-white font-bold">{buildTasks.length}</span>
          </div>
          <div>
            <span className="text-slate-500 uppercase">Active Leads: </span>
            <span className="text-white font-bold">{activeOpportunities.length}</span>
          </div>
          <div>
            <span className="text-slate-500 uppercase">Commission Pending: </span>
            <span className="text-emerald-400 font-bold">£{commissions.reduce((acc, c) => acc + (parseFloat(c.estimatedCommission) || 0), 0).toFixed(2)}</span>
          </div>
        </div>
      </div>

      {/* CORE NAVIGATION */}
      <div className="flex flex-wrap gap-2 border-b border-zinc-900 pb-3 text-xs font-mono font-black uppercase">
        <button onClick={() => setConsoleTab('missions')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'missions' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <ListTodo size={13} />
          <span>My Tasks</span>
        </button>
        <button onClick={() => setConsoleTab('workbench')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'workbench' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <Compass size={13} />
          <span>Available Tasks</span>
        </button>
        <button onClick={() => setConsoleTab('studio')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'studio' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <Briefcase size={13} />
          <span>Submit Work</span>
        </button>
        <button onClick={() => setConsoleTab('verification')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'verification' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <ShieldAlert size={13} />
          <span>My Verification Status</span>
        </button>
        <button onClick={() => setConsoleTab('preview')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'preview' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <Eye size={13} />
          <span>My Agreement</span>
        </button>
        <button onClick={() => setConsoleTab('commissions')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'commissions' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <DollarSign size={13} />
          <span>My Commission Estimate</span>
        </button>
        <button onClick={() => setConsoleTab('training')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'training' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20' : 'text-slate-500'}`}>
          <BookOpen size={13} />
          <span>Help / Rules</span>
        </button>
        {["DIRECTOR", "ADMIN", "SUPER_ADMIN"].includes(currentProfile?.role) && (
          <button onClick={() => setConsoleTab('control')} className={`py-1.5 px-3.5 rounded-xl cursor-pointer hover:bg-zinc-900/40 transition-all flex items-center gap-1.5 ${consoleTab === 'control' ? 'bg-purple-950/40 text-purple-300 border border-purple-500/20 animate-pulse' : 'text-rose-500'}`}>
            <ShieldCheck size={13} />
            <span>Remote Workforce Control</span>
          </button>
        )}
      </div>

      {/* CORE VIEWPORTS */}
      <div className="bg-black/60 rounded-3xl border border-zinc-900 p-6 space-y-6">

        {/* 1. OPPORTUNITY WORKBENCH */}
        {consoleTab === 'workbench' && (
          <div className="space-y-6 text-left">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <Compass size={16} className="text-purple-400" />
                <span>Opportunity Workbench</span>
              </h2>
              <p className="text-[10px] font-mono text-slate-500 uppercase pt-1">
                Conduct business lead research, weakness checks, and outreach draft assemblies
              </p>
            </div>

            {/* Sub navigation */}
            <div className="flex flex-wrap gap-1.5 text-[10.5px] font-mono font-bold uppercase bg-zinc-950/60 p-1.5 rounded-2xl border border-zinc-900">
              <button onClick={() => setWorkbenchSubtab('leadFinder')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'leadFinder' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Lead Finder & Active Queue
              </button>
              <button onClick={() => setWorkbenchSubtab('analyzer')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'analyzer' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Business Opportunity Analyzer
              </button>
              <button onClick={() => setWorkbenchSubtab('checker')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'checker' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Website Checker
              </button>
              <button onClick={() => setWorkbenchSubtab('outreach')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'outreach' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Outreach Draft Prep
              </button>
              <button onClick={() => setWorkbenchSubtab('productQueue')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'productQueue' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Product Link Analyzer
              </button>
              <button onClick={() => setWorkbenchSubtab('completedHistory')} className={`py-1 px-3 rounded-xl cursor-pointer ${workbenchSubtab === 'completedHistory' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                Completed Lead History
              </button>
            </div>

            <div className="space-y-4">
              
              {/* Lead Finder */}
              {workbenchSubtab === 'leadFinder' && (
                <div className="space-y-6 font-mono text-xs">
                  
                  {/* Scraper Suggestions Hint Panel */}
                  <div className="p-4 bg-purple-950/15 border border-purple-500/20 rounded-2xl space-y-2">
                    <div className="text-cyan-400 font-bold uppercase text-[9.5px] flex items-center gap-1">
                      <Sparkles size={12} />
                      <span>NexoraX Lead Advisor Suggestions Hint Panel</span>
                    </div>
                    <div className="text-slate-400 text-[10px] leading-relaxed">
                      💡 **Dental/Medical**: check if booking option is visible on mobile viewports. <br />
                      💡 **Restaurant**: check Google review count vs website order capability. <br />
                      💡 **Trades**: check for online quote forms and mobile responsiveness.
                    </div>
                  </div>

                  {/* Scraper Search Panel */}
                  <form onSubmit={handleLeadSearch} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5 flex justify-between">
                      <span>LOCAL BUSINESS OPPORTUNITY CRAWLER</span>
                      <span className="text-cyan-400 text-[9px]">CRAWLER Node-07 ACTIVE</span>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Business Keyword / Industry</label>
                        <input type="text" value={leadSearchForm.keyword} onChange={(e) => setLeadSearchForm({ ...leadSearchForm, keyword: e.target.value })} placeholder="e.g. bakery, courier, clinic" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Location</label>
                        <input type="text" value={leadSearchForm.location} onChange={(e) => setLeadSearchForm({ ...leadSearchForm, location: e.target.value })} placeholder="e.g. Dunfermline, Fife" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Opportunity Type</label>
                        <select value={leadSearchForm.opportunityType} onChange={(e) => setLeadSearchForm({ ...leadSearchForm, opportunityType: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          {OPPORTUNITY_TYPES.map((t, idx) => (
                            <option key={idx} value={t}>{t}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <button type="submit" className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Search Opportunities
                    </button>
                  </form>

                  {/* Scrape results with auto-save indicators */}
                  {searchedLeads.length > 0 && (
                    <div className="space-y-3">
                      <div className="text-white font-bold uppercase text-[10.5px] flex justify-between">
                        <span>Search Results:</span>
                        <span className="text-emerald-400">✓ Auto-saved to Opportunities queue</span>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {searchedLeads.map((lead, idx) => (
                          <div key={idx} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-2 text-left">
                            <div className="flex justify-between items-start">
                              <h4 className="text-white font-bold text-[13px]">{lead.businessName}</h4>
                              <span className={`px-2 py-0.5 rounded text-[9px] uppercase font-bold ${
                                lead.isDuplicate ? 'bg-amber-500/20 text-amber-300' : 'bg-emerald-500/20 text-emerald-300'
                              }`}>
                                {lead.isDuplicate ? lead.duplicateBadge : (lead.status || 'Saved')}
                              </span>
                            </div>
                            <div className="text-[10px] text-slate-400 space-y-1">
                              <div>📍 Location: {lead.location}</div>
                              <div>🌐 Link: {lead.websiteUrl || 'none'}</div>
                              <div>⭐ Reviews: {lead.reviewScore} ({lead.reviewCount})</div>
                              <div className="text-amber-400">⚠️ Weakness: {lead.notes || lead.digitalWeakness}</div>
                            </div>
                            {!lead.isDuplicate && (
                              <button onClick={() => handleClaimOpportunity(lead.id)} className="px-3 py-1 bg-purple-650 hover:bg-purple-600 text-white font-black rounded text-[9.5px] uppercase cursor-pointer">
                                Claim Lead & Start Checklist
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* ACTIVE OPPORTUNITIES QUEUE */}
                  <div className="space-y-3 border-t border-zinc-900 pt-6">
                    <div className="text-white font-bold uppercase text-[11px] tracking-wider flex items-center gap-1">
                      <ClipboardList size={14} className="text-purple-400" />
                      <span>Active Leads Queue</span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                      {activeOpportunities.map((opp) => (
                        <div key={opp.id} className={`p-4 bg-zinc-950 border rounded-2xl space-y-3 transition-all ${
                          selectedLeadForChecklist?.id === opp.id ? 'border-purple-500 shadow-[0_0_15px_rgba(168,85,247,0.1)]' : 'border-zinc-900'
                        }`}>
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="text-white font-bold text-sm">{opp.businessName}</h4>
                              <span className="px-2 py-0.5 bg-zinc-800 text-zinc-400 rounded text-[9px] uppercase font-bold">{opp.status}</span>
                            </div>
                            <span className="text-[10px] text-slate-500">{opp.location}</span>
                          </div>

                          {/* Lead Checklist Form Panel */}
                          {selectedLeadForChecklist?.id === opp.id ? (
                            <div className="p-3 bg-purple-950/15 border border-purple-500/25 rounded-xl space-y-3">
                              <div className="text-white font-bold uppercase text-[9.5px] border-b border-purple-500/20 pb-1 flex items-center gap-1">
                                <UserCheck size={11} className="text-purple-400" />
                                <span>Checklist Progress</span>
                              </div>
                              <div className="space-y-1.5 text-[10px] text-slate-400">
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" checked={leadChecklist.reviewedName} onChange={(e) => setLeadChecklist({ ...leadChecklist, reviewedName: e.target.checked })} />
                                  <span>Reviewed Business Name</span>
                                </label>
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" checked={leadChecklist.checkedWebsite} onChange={(e) => setLeadChecklist({ ...leadChecklist, checkedWebsite: e.target.checked })} />
                                  <span>Checked Website Presence</span>
                                </label>
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" checked={leadChecklist.checkedSocial} onChange={(e) => setLeadChecklist({ ...leadChecklist, checkedSocial: e.target.checked })} />
                                  <span>Checked Social Pages</span>
                                </label>
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" checked={leadChecklist.checkedReviews} onChange={(e) => setLeadChecklist({ ...leadChecklist, checkedReviews: e.target.checked })} />
                                  <span>Checked Review Profile</span>
                                </label>
                                <label className="flex items-center gap-2">
                                  <input type="checkbox" checked={leadChecklist.ranAdvisorAnalysis} onChange={(e) => setLeadChecklist({ ...leadChecklist, ranAdvisorAnalysis: e.target.checked })} />
                                  <span>Ran Advisor Analysis</span>
                                </label>
                              </div>

                              <div className="flex flex-wrap gap-1.5 pt-2">
                                <button onClick={() => handleAnalyseLeadChecklist(opp.id)} className="px-2.5 py-1 bg-cyan-600 hover:bg-cyan-500 text-slate-950 font-black rounded text-[9px] uppercase cursor-pointer">
                                  Analyse Lead
                                </button>
                                <button onClick={() => {
                                  setOutreachForm({
                                    selectedOppId: opp.id,
                                    businessName: opp.businessName,
                                    outreachAngle: 'Introduce LaunchCare professional website setup and custom branding.',
                                    painPoint: opp.notes || 'Mobile optimization and conversion rates',
                                    suggestedImprovement: 'A fast-loading checkout landing page',
                                    messageTone: 'Professional & Direct',
                                    notes: '',
                                    recipientEmail: opp.publicEmail || ''
                                  });
                                  setWorkbenchSubtab('outreach');
                                }} className="px-2.5 py-1 bg-zinc-900 border border-zinc-800 text-slate-300 font-bold rounded text-[9px] uppercase cursor-pointer">
                                  Prepare Outreach Draft
                                </button>
                                <button onClick={() => handleMarkLeadDone(opp.id)} className="px-2.5 py-1 bg-emerald-600 hover:bg-emerald-500 text-white font-black rounded text-[9px] uppercase cursor-pointer">
                                  Mark Done
                                </button>
                                <button onClick={() => handleMarkLeadNotSuitable(opp.id)} className="px-2.5 py-1 bg-rose-950 text-rose-400 border border-rose-500/20 rounded text-[9px] uppercase cursor-pointer">
                                  Not Suitable
                                </button>
                              </div>
                            </div>
                          ) : (
                            <button onClick={() => handleClaimOpportunity(opp.id)} className="w-full py-1.5 bg-zinc-900 border border-zinc-850 text-slate-300 font-bold rounded-xl uppercase text-[9.5px]">
                              Select to process Lead
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                </div>
              )}

              {/* Business Opportunity Analyzer */}
              {workbenchSubtab === 'analyzer' && (
                <div className="space-y-6 font-mono text-xs text-left">
                  <form onSubmit={handleAnalyseBusiness} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5 flex justify-between">
                      <span>NEXORAX ADVISOR BUSINESS AUDIT</span>
                      <span className="text-purple-400">COGNITIVE MATRIX ACTIVATE</span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Business Name</label>
                        <input type="text" value={analyzerForm.businessName} onChange={(e) => setAnalyzerForm({ ...analyzerForm, businessName: e.target.value })} placeholder="e.g. Deeside Logistics" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Website URL</label>
                        <input type="text" value={analyzerForm.websiteUrl} onChange={(e) => setAnalyzerForm({ ...analyzerForm, websiteUrl: e.target.value })} placeholder="www.example.co.uk" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Social Page URL</label>
                        <input type="text" value={analyzerForm.socialUrl} onChange={(e) => setAnalyzerForm({ ...analyzerForm, socialUrl: e.target.value })} placeholder="facebook.com/example" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Problem Noticed</label>
                        <input type="text" value={analyzerForm.problemSpotted} onChange={(e) => setAnalyzerForm({ ...analyzerForm, problemSpotted: e.target.value })} placeholder="e.g. Lacks mobile scheduling forms." className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Suggested Service</label>
                        <select value={analyzerForm.suggestedService} onChange={(e) => setAnalyzerForm({ ...analyzerForm, suggestedService: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          {OPPORTUNITY_TYPES.map((t, idx) => (
                            <option key={idx} value={t}>{t}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <button type="submit" className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Analyse with NexoraX Advisor
                    </button>
                  </form>

                  {advisorAnalysis && (
                    <div className="p-6 bg-purple-950/20 border border-purple-500/30 rounded-3xl space-y-3">
                      <div className="text-cyan-400 font-bold uppercase text-[10px] tracking-widest flex items-center gap-1">
                        <Sparkles size={13} />
                        <span>NexoraX Advisor Performance Audit</span>
                      </div>
                      <pre className="text-slate-300 whitespace-pre-wrap font-sans text-xs leading-relaxed lowercase bg-black/40 p-4 rounded-2xl border border-zinc-900">
                        {typeof advisorAnalysis === 'string' ? advisorAnalysis : (advisorAnalysis.rawText || JSON.stringify(advisorAnalysis, null, 2))}
                      </pre>
                    </div>
                  )}

                </div>
              )}

              {/* Website Checker */}
              {workbenchSubtab === 'checker' && (
                <div className="space-y-6 font-mono text-xs text-left">
                  <form onSubmit={handleCalculateChecker} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5">
                      WEBSITE DESIGN VITAL MARKS
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Website Exists?</label>
                        <select value={checkerForm.websiteExists} onChange={(e) => setCheckerForm({ ...checkerForm, websiteExists: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Mobile Quality</label>
                        <select value={checkerForm.mobileQuality} onChange={(e) => setCheckerForm({ ...checkerForm, mobileQuality: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          <option>Excellent</option>
                          <option>Average</option>
                          <option>Poor</option>
                        </select>
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">CTA Button Visible?</label>
                        <select value={checkerForm.ctaVisible} onChange={(e) => setCheckerForm({ ...checkerForm, ctaVisible: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-1">
                      <label className="text-[10px] text-slate-500 uppercase font-bold">Issue Spotted</label>
                      <input type="text" value={checkerForm.problemSpotted} onChange={(e) => setCheckerForm({ ...checkerForm, problemSpotted: e.target.value })} placeholder="e.g. Lacks pricing details" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                    </div>

                    <button type="submit" className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Run Recommendations Rule Check
                    </button>
                  </form>

                  {checkerResult && (
                    <div className="p-5 bg-purple-950/20 border border-purple-500/30 rounded-3xl space-y-2">
                      <div className="text-cyan-400 font-bold uppercase text-[9.5px]">Auto Checker Recommendation</div>
                      <div className="text-white text-xs font-black uppercase">Opportunity Score: {checkerResult.opportunityScore}</div>
                      <div className="text-slate-300">Suggested offer: {checkerResult.suggestedOffer}</div>
                      <p className="text-slate-400 text-[10.5px] leading-relaxed">{checkerResult.reason}</p>
                    </div>
                  )}

                </div>
              )}

              {/* Outreach Draft Prep */}
              {workbenchSubtab === 'outreach' && (
                <div className="space-y-6 font-mono text-xs text-left">
                  <form onSubmit={handleGenerateOutreach} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5">
                      CONSTRUCT OUTREACH PROPOSAL DRAFT
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Target Business</label>
                        <input type="text" value={outreachForm.businessName} onChange={(e) => setOutreachForm({ ...outreachForm, businessName: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Recipient Business Email</label>
                        <input type="email" value={outreachForm.recipientEmail} onChange={(e) => setOutreachForm({ ...outreachForm, recipientEmail: e.target.value })} placeholder="info@company.com" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Noticed Pain Point</label>
                        <input type="text" value={outreachForm.painPoint} onChange={(e) => setOutreachForm({ ...outreachForm, painPoint: e.target.value })} placeholder="e.g. mobile conversion delays" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Suggested Improvement</label>
                        <input type="text" value={outreachForm.suggestedImprovement} onChange={(e) => setOutreachForm({ ...outreachForm, suggestedImprovement: e.target.value })} placeholder="e.g. LaunchCare web setup" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                    </div>

                    <button type="submit" className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                      Generate Outreach Draft
                    </button>
                  </form>

                  {generatedOutreachText && (
                    <div className="space-y-3">
                      <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-3xl space-y-2">
                        <div className="text-white font-bold uppercase text-[9.5px]">PROSPECT OUTREACH BODY PREVIEW:</div>
                        <textarea readOnly value={generatedOutreachText} rows={10} className="w-full bg-black border border-zinc-900 p-3 rounded-2xl text-slate-300 font-mono text-[11px] leading-relaxed resize-none outline-none" />
                      </div>

                      <div className="flex gap-2">
                        <button onClick={handleSaveOutreach} className="px-4 py-2 bg-purple-650 hover:bg-purple-600 text-white font-black uppercase rounded-xl cursor-pointer flex items-center gap-1">
                          <Send size={12} />
                          <span>Submit for Director Approval</span>
                        </button>
                      </div>
                    </div>
                  )}

                </div>
              )}

              {/* Product Link Analyzer */}
              {workbenchSubtab === 'productQueue' && (
                <div className="space-y-6 font-mono text-xs text-left">
                  
                  {/* NexoraX Product Discovery Panel */}
                  <div className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5 flex justify-between">
                      <span>NEXORAX PRODUCT DISCOVERY SUGGESTIONS</span>
                      <span className="text-cyan-400">TREND ANALYSIS ENGINE</span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Product / Trend Title</label>
                        <input type="text" value={productResearchForm.productName} onChange={(e) => setProductResearchForm({ ...productResearchForm, productName: e.target.value })} placeholder="e.g. Smart Wallet Widget" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Source Link / Video Link</label>
                        <input type="text" value={productResearchForm.sourceLink} onChange={(e) => setProductResearchForm({ ...productResearchForm, sourceLink: e.target.value })} placeholder="tiktok.com/..." className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                      </div>
                      <div className="space-y-1">
                        <label className="text-[10px] text-slate-500 uppercase font-bold">Source Platform</label>
                        <select value={productResearchForm.sourceType} onChange={(e) => setProductResearchForm({ ...productResearchForm, sourceType: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none">
                          <option>TikTok</option>
                          <option>YouTube</option>
                          <option>Amazon</option>
                          <option>Alibaba</option>
                          <option>Manual observation</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-1">
                      <label className="text-[10px] text-slate-500 uppercase font-bold">Why it could sell / notes</label>
                      <input type="text" value={productResearchForm.whyItCouldSell} onChange={(e) => setProductResearchForm({ ...productResearchForm, whyItCouldSell: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" />
                    </div>

                    <div className="flex gap-2">
                      <button type="button" onClick={handleGetProductSuggestions} className="px-4 py-2.5 bg-zinc-900 hover:bg-zinc-850 border border-zinc-800 text-slate-300 font-bold uppercase rounded-xl cursor-pointer">
                        Generate Research Suggestions
                      </button>
                      <button type="submit" onClick={handleAddProductResearch} className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                        Analyse Product with NexoraX Advisor
                      </button>
                    </div>
                  </div>

                  {productSuggestions && (
                    <div className="p-5 bg-purple-950/15 border border-purple-500/20 rounded-2xl space-y-2">
                      <div className="text-cyan-400 font-bold uppercase text-[9.5px]">NexoraX Product Discovery Suggestions</div>
                      <pre className="text-slate-300 whitespace-pre-wrap font-sans text-xs leading-relaxed lowercase bg-black/40 p-4 rounded-2xl border border-zinc-900">
                        {productSuggestions}
                      </pre>
                    </div>
                  )}

                  {productAnalysisResult && (
                    <div className="p-5 bg-purple-950/20 border border-purple-500/30 rounded-3xl space-y-3">
                      <div className="text-cyan-400 font-bold uppercase text-[9.5px]">Advisor Analysis Report</div>
                      <pre className="text-slate-300 whitespace-pre-wrap font-sans text-xs leading-relaxed lowercase bg-black/40 p-4 rounded-2xl border border-zinc-900">
                        {productAnalysisResult}
                      </pre>
                    </div>
                  )}

                </div>
              )}

              {/* Completed Lead History */}
              {workbenchSubtab === 'completedHistory' && (
                <div className="space-y-4 font-mono text-xs text-left">
                  <div className="text-white font-bold uppercase text-[10.5px] border-b border-zinc-900 pb-1.5 flex justify-between">
                    <span>COMPLETED / ARCHIVED OPPORTUNITIES HISTORY</span>
                    <span className="text-slate-500">Read-Only Archive</span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {completedOpportunities.length === 0 ? (
                      <div className="col-span-2 text-center text-slate-500 py-6 border border-zinc-900 rounded-2xl">
                        No completed leads found.
                      </div>
                    ) : (
                      completedOpportunities.map((opp) => (
                        <div key={opp.id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-2 text-left">
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="text-slate-300 font-bold text-sm">{opp.businessName}</h4>
                              <span className="px-2 py-0.5 bg-zinc-900 text-zinc-500 rounded text-[9px] uppercase font-bold">{opp.status}</span>
                            </div>
                            <span className="text-[10px] text-slate-500">{opp.location}</span>
                          </div>
                          <div className="text-[10px] text-slate-500">
                            <div>Website: {opp.websiteUrl || 'none'}</div>
                            <div>Suggested: {opp.suggestedService}</div>
                          </div>
                          
                          {/* Director reopen button */}
                          {(userRole === 'ADMIN' || userRole === 'DIRECTOR' || userRole === 'SUPER_ADMIN') && (
                            <button onClick={() => handleReopenLead(opp.id)} className="px-2.5 py-1 bg-purple-650 hover:bg-purple-600 text-white font-black rounded text-[9px] uppercase cursor-pointer">
                              Reopen Lead (Director Override)
                            </button>
                          )}
                        </div>
                      ))
                    )}
                  </div>

                </div>
              )}

            </div>
          </div>
        )}

        {/* 2. WORK MISSION BOARD */}
        {consoleTab === 'missions' && (
          <div className="space-y-4">
            <div className="border-b border-white/5 pb-3 flex justify-between items-center">
              <div>
                <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                  <ListTodo size={16} className="text-purple-400" />
                  <span>Work Mission Board</span>
                </h2>
                <p className="text-[10px] font-mono text-slate-500 uppercase pt-1">
                  Manage assigned daily tasks and track commission eligibility
                </p>
              </div>
              <button onClick={syncData} className="p-2 bg-zinc-900 border border-zinc-850 hover:bg-zinc-850 text-slate-300 rounded-xl cursor-pointer">
                <RefreshCw size={11} className={loading ? "animate-spin" : ""} />
              </button>
            </div>

            <div className="flex gap-1.5 text-[10.5px] font-mono font-bold uppercase bg-zinc-950/60 p-1.5 rounded-2xl border border-zinc-900 w-max">
              <button type="button" onClick={() => setWorkerMissionsTab('production')} className={`py-1 px-3 rounded-xl cursor-pointer ${workerMissionsTab === 'production' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                🚀 Production Tasks
              </button>
              <button type="button" onClick={() => setWorkerMissionsTab('build')} className={`py-1 px-3 rounded-xl cursor-pointer ${workerMissionsTab === 'build' ? 'bg-purple-950/40 text-purple-300' : 'text-slate-500'}`}>
                ⚙️ System Build Tasks
              </button>
            </div>

            {workerMissionsTab === 'production' ? (
              renderWorkerProductionTasks()
            ) : (
              <div className="grid grid-cols-1 gap-4">
                {buildTasks.map((task) => (
                  <div key={task.id} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl text-xs font-mono space-y-3">
                    <div className="flex justify-between items-start flex-wrap gap-2 text-left">
                      <div className="space-y-1">
                        <div className="flex items-center gap-2">
                          <span className="px-2 py-0.5 bg-purple-500/20 text-purple-300 rounded text-[9px] font-black uppercase">
                            {task.category}
                          </span>
                          <span className="px-2 py-0.5 bg-zinc-800 text-slate-300 rounded text-[9px] font-bold">
                            {task.priority || 'MEDIUM'}
                          </span>
                        </div>
                        <h3 className="text-white font-sans text-sm font-black uppercase">{task.title}</h3>
                      </div>
                      <div className="text-right">
                        <div className="text-[10px] text-slate-500">DUE DATE: {task.dueDate}</div>
                        <div className="pt-1.5">
                          <span className={`px-2.5 py-0.5 rounded-full text-[9px] font-bold uppercase ${
                            task.status === 'Approved' ? 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30' :
                            task.status === 'Submitted' ? 'bg-purple-500/15 text-purple-400 border border-purple-500/30' :
                            task.status === 'Ready for Director Review' ? 'bg-cyan-500/15 text-cyan-400 border border-cyan-500/30' :
                            'bg-zinc-800 text-zinc-400 border border-zinc-700/30'
                          }`}>
                            {task.status}
                          </span>
                        </div>
                      </div>
                    </div>

                    <p className="p-3 bg-black/60 border border-zinc-900 rounded-xl leading-relaxed text-slate-400 text-[11px] normal-case text-left">
                      {task.brief}
                    </p>

                    <div className="flex gap-2 pt-2 border-t border-white/5 flex-wrap">
                      {task.status === 'Assigned' && (
                        <button onClick={() => handleStartTask(task.id)} className="px-3.5 py-1.5 bg-purple-650 hover:bg-purple-600 text-white font-black text-[9px] uppercase tracking-wider rounded-lg cursor-pointer">
                          Start Task
                        </button>
                      )}
                      <button onClick={() => setConsoleTab('preview')} className="px-3.5 py-1.5 bg-zinc-900 border border-zinc-850 text-slate-300 font-black text-[9px] uppercase tracking-wider rounded-lg cursor-pointer">
                        View Draft Preview
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* 3. LIVE DRAFT PREVIEW */}
        {consoleTab === 'preview' && (
          <div className="space-y-6 font-mono text-xs">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <Eye size={16} className="text-purple-400" />
                <span>Live Draft Preview & Visual Feedback Layer</span>
              </h2>
              <p className="text-[10px] text-slate-500 uppercase pt-1">
                Verify templates and submit visual audits to the Director
              </p>
            </div>

            {previewsList.map((p) => (
              <div key={p.id} className="grid grid-cols-1 lg:grid-cols-3 gap-6 text-left">
                
                {/* Visual Viewport */}
                <div className="lg:col-span-2 space-y-4">
                  <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-3xl space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-white font-bold uppercase text-[10px] tracking-wide flex items-center gap-1">
                        <Monitor size={12} className="text-purple-400" />
                        <span>Desktop & Mobile Mockup Viewport</span>
                      </span>
                      <span className="px-2 py-0.5 bg-purple-500/10 text-purple-300 border border-purple-500/20 rounded text-[9px] uppercase font-bold">
                        {p.status}
                      </span>
                    </div>

                    <div className="w-full h-80 bg-zinc-900 border border-zinc-800 rounded-2xl flex flex-col items-center justify-center relative overflow-hidden">
                      {p.screenshotRef ? (
                        <div className="w-full h-full p-2 space-y-2">
                          <div className="text-[9px] text-slate-500">Live screenshot URL: {p.screenshotRef}</div>
                          <div className="w-full h-64 bg-zinc-950 rounded border border-zinc-850 flex items-center justify-center text-slate-400">
                            [ Visual Mockup Frame Loaded: {p.screenshotRef} ]
                          </div>
                        </div>
                      ) : (
                        <div className="text-center space-y-2 text-slate-500 p-6">
                          <Smartphone size={40} className="mx-auto opacity-40 animate-pulse text-purple-400" />
                          <p className="text-[10px] uppercase font-bold text-slate-400">Awaiting operator screenshot/export reference</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {editingPreviewId === p.id ? (
                    <form onSubmit={handleSavePreview} className="p-5 bg-zinc-950 border border-zinc-900 rounded-3xl space-y-4">
                      <div className="text-white font-bold uppercase text-[10px] tracking-wide border-b border-zinc-900 pb-1.5">
                        EDIT DRAFT VIEWPORT SPECIFICATIONS
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="space-y-1">
                          <label className="text-[9.5px] uppercase font-bold text-slate-400">Desktop Mockup URL</label>
                          <input type="text" value={previewForm.desktopPreviewRef} onChange={(e) => setPreviewForm({ ...previewForm, desktopPreviewRef: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white" />
                        </div>
                        <div className="space-y-1">
                          <label className="text-[9.5px] uppercase font-bold text-slate-400">Mobile Mockup URL</label>
                          <input type="text" value={previewForm.mobilePreviewRef} onChange={(e) => setPreviewForm({ ...previewForm, mobilePreviewRef: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white" />
                        </div>
                        <div className="space-y-1">
                          <label className="text-[9.5px] uppercase font-bold text-slate-400">Screenshot Link</label>
                          <input type="text" value={previewForm.screenshotRef} onChange={(e) => setPreviewForm({ ...previewForm, screenshotRef: e.target.value })} className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white" required />
                        </div>
                      </div>

                      <div className="flex gap-2">
                        <button type="button" onClick={() => setEditingPreviewId(null)} className="px-3.5 py-1.5 bg-zinc-900 border border-zinc-800 text-slate-400 font-bold uppercase rounded-lg cursor-pointer">
                          Cancel
                        </button>
                        <button type="submit" className="px-3.5 py-1.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-lg cursor-pointer">
                          Save Layout Details
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div className="p-4 bg-zinc-950 border border-zinc-900 rounded-3xl flex justify-between items-center">
                      <div className="text-[10px] text-slate-500">COMPLETE VISUAL DETAILS MATRIX:</div>
                      <button onClick={() => {
                        setEditingPreviewId(p.id);
                        setPreviewForm({
                          desktopPreviewRef: p.desktopPreviewRef || '',
                          mobilePreviewRef: p.mobilePreviewRef || '',
                          screenshotRef: p.screenshotRef || '',
                          visualFeedbackNotes: p.visualFeedbackNotes || '',
                          designImprovementNotes: p.designImprovementNotes || '',
                          blockers: p.blockers || '',
                          completionPercentage: String(p.completionPercentage || 0)
                        });
                      }} className="px-3.5 py-1.5 bg-purple-650 hover:bg-purple-600 text-white font-black uppercase rounded-xl cursor-pointer">
                        Edit Layout Preview
                      </button>
                    </div>
                  )}
                </div>

                {/* AI Review Sidebar */}
                <div className="col-span-1 space-y-4 text-left">
                  <div className="p-5 bg-zinc-950 border border-zinc-900 rounded-3xl space-y-4">
                    <div className="text-white font-bold uppercase text-[10px] tracking-wide border-b border-zinc-900 pb-1.5 flex items-center gap-1">
                      <CheckSquare size={13} className="text-cyan-400" />
                      <span>AI Quality Review Checklist</span>
                    </div>

                    <div className="space-y-2">
                      {Object.keys(designReviewChecklist).map((key) => (
                        <label key={key} className="flex items-center gap-2 p-1.5 bg-black/40 rounded-lg cursor-pointer hover:bg-black/60">
                          <input 
                            type="checkbox"
                            checked={(designReviewChecklist as any)[key]}
                            onChange={(e) => setDesignReviewChecklist({ ...designReviewChecklist, [key]: e.target.checked })}
                            className="rounded border-zinc-800 text-purple-650 focus:ring-0 cursor-pointer"
                          />
                          <span className="capitalize text-[10px] text-slate-400">
                            {key.replace(/([A-Z])/g, ' $1')}
                          </span>
                        </label>
                      ))}
                    </div>

                    <div className="pt-2">
                      <button onClick={() => handleSubmitPreviewReview(p.id)} className="w-full py-2 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase tracking-wider rounded-xl cursor-pointer shadow-[0_0_15px_rgba(168,85,247,0.3)]">
                        Submit Preview for AI Quality Review
                      </button>
                    </div>
                  </div>

                  {aiReviewFeedback && (
                    <div className="p-5 bg-purple-950/20 border border-purple-500/35 rounded-3xl space-y-2.5">
                      <div className="text-cyan-400 font-bold uppercase text-[9px] tracking-widest flex items-center gap-0.5">
                        <Sparkles size={11} />
                        <span>NexoraX Advisor Feedback</span>
                      </div>
                      <div className="text-white text-xs font-black uppercase">Decision: {aiReviewFeedback.decision}</div>
                      <p className="text-slate-400 text-[10.5px] leading-relaxed normal-case">{aiReviewFeedback.why}</p>
                    </div>
                  )}
                </div>

              </div>
            ))}
          </div>
        )}

        {/* 4. PRODUCTION STUDIO */}
        {consoleTab === 'studio' && (
          <div className="space-y-4 text-left font-mono text-xs">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <Briefcase size={16} className="text-purple-400" />
                <span>Production Studio</span>
              </h2>
              <p className="text-[10px] text-slate-500 uppercase pt-1">
                Construct and preview active layout screen modules
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4">
              <div className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-white font-bold text-sm">Screen 10 — Add-ons Module Selector</span>
                  <span className="px-2 py-0.5 bg-amber-500/15 text-amber-400 rounded text-[9px]">Awaiting Preview Setup</span>
                </div>
                <button onClick={() => setConsoleTab('preview')} className="px-3.5 py-1.5 bg-purple-650 hover:bg-purple-600 text-white font-black uppercase rounded-lg cursor-pointer">
                  Open Design Preview Workspace
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 5. IDEA REVIEW */}
        {consoleTab === 'suggestions' && (
          <div className="space-y-6 text-left font-mono text-xs">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <MessageSquare size={16} className="text-purple-400" />
                <span>Idea Review & Improvements</span>
              </h2>
              <p className="text-[10px] text-slate-500 uppercase pt-1">
                Suggest modifications to layouts and retrieve automated Advisor responses
              </p>
            </div>

            <form onSubmit={handleSuggestImprovement} className="p-5 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="text-[10px] text-slate-500 uppercase font-bold">Suggestion Title</label>
                  <input type="text" value={suggestionForm.title} onChange={(e) => setSuggestionForm({ ...suggestionForm, title: e.target.value })} placeholder="e.g. Add GBP checkout button" className="w-full bg-black border border-zinc-800 p-2.5 rounded-xl text-white outline-none" required />
                </div>
              </div>
              <button type="submit" className="px-4 py-2.5 bg-gradient-to-r from-purple-500 to-fuchsia-500 text-white font-black uppercase rounded-xl cursor-pointer">
                Log Suggestion & Run Advisor Review
              </button>
            </form>
          </div>
        )}

        {/* 6. COMMISSION TRACKER */}
        {consoleTab === 'commissions' && (
          <div className="space-y-4 text-left font-mono text-xs">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <DollarSign size={16} className="text-purple-400" />
                <span>Commission Tracker</span>
              </h2>
              <p className="text-[10px] text-slate-500 uppercase pt-1">
                Monitor estimates, linked checkouts, and pending Director approvals
              </p>
            </div>

            <div className="p-4 bg-purple-950/15 border border-purple-500/20 rounded-xl text-[11px] leading-relaxed text-purple-300">
              ⚠️ **Staging Disclaimer**: Commission amounts are estimated. Final payouts are subject to Director validation and actual customer payment clearances.
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {commissions.length === 0 ? (
                <div className="col-span-2 text-center text-slate-500 py-6 border border-zinc-900 rounded-2xl">No commission logs present yet.</div>
              ) : (
                commissions.map((comm) => (
                  <div key={comm.id} className="p-4 bg-zinc-950 border border-zinc-900 rounded-2xl space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-white font-bold">{comm.commissionType}</span>
                      <span className="text-cyan-400 font-bold">£{parseFloat(comm.estimatedCommission).toFixed(2)}</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
        {/* 8. REMOTE WORKFORCE CONTROL (Director/Admin Privilege Only) */}
        {consoleTab === 'control' && ["DIRECTOR", "ADMIN", "SUPER_ADMIN"].includes(currentProfile?.role) && renderDirectorControlDashboard()}

        {/* 7. RULES */}
        {consoleTab === 'training' && (
          <div className="space-y-4 text-left font-mono text-xs">
            <div className="border-b border-white/5 pb-3">
              <h2 className="text-base font-black uppercase text-white tracking-tight flex items-center gap-2">
                <BookOpen size={16} className="text-purple-400" />
                <span>Operator Rules & Guidelines</span>
              </h2>
              <p className="text-[10px] text-slate-500 uppercase pt-1">
                Core rules for conducting sandboxed digital operations
              </p>
            </div>

            <div className="p-5 bg-zinc-950 border border-zinc-900 rounded-3xl space-y-3 leading-relaxed text-slate-300">
              <div className="text-white font-bold uppercase text-xs mb-2">OPERATOR SECURITY BOUNDS:</div>
              <div>• All proposals and outreach drafts are held in a review queue. No outbound messages are dispatched directly.</div>
              <div>• Never discuss AI models, studio keys, code scripts, or prompt texts. Focus entirely on client design checks and GBP pricing.</div>
              <div>• All active builds require complete reviews before submission to the Director queue.</div>
            </div>
          </div>
        )}

        {consoleTab === 'verification' && renderWorkerVerificationTab()}

        {/* Remote Workforce OS Upgrade Modals */}
        {renderWorkforceDirectorModals()}
        {renderWorkforceWorkerModals()}
        {renderVerificationReviewModal()}

      </div>
    </div>
  );
};
